import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as PdfMake from "pdfmake/build/pdfmake";
import * as PdfFonts from 'pdfmake/build/vfs_fonts';
(<any>PdfMake).addVirtualFileSystem(PdfFonts);
import { CommonModule, Location } from '@angular/common';
import { ApiService } from 'shared/services/api.service';
import { AuthService } from 'shared/services/auth.service';
import { BehaviorSubject, Subscription, combineLatest, finalize, take } from 'rxjs';
import { SettingsService } from 'shared/services/settings.service';
import { DialogService } from 'shared/services/dialog.service';
import { debounce } from 'lodash';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SynchronizationService } from 'shared/services/synchronization.service';
import { DbDocumentObject, DocumentsService } from 'shared/services/documents.service';
import { DataSynchronizerService } from 'shared/services/data-synchronization.service';
import { InvoicePreviewService } from 'shared/services/invoice-preview.service';
import { ToastService } from 'shared/services/toast.service';
import { NotificationData, NumberingTypes, ObjectUtils, PriceInputMode } from 'fakturnia-shared';
import { ProductsService } from 'shared/services/products.service';
import { cloneDeep } from 'lodash'
import { BankAccountsApiService } from 'shared/services/api/bank-accounts.api.service';
import { Invoice, InvoiceAnnotations } from 'fakturnia-shared';
import { AutoAnnotationUtils } from 'fakturnia-shared';
import { AppData } from 'fakturnia-shared';
import { DbProduct } from 'fakturnia-shared';
import { Company } from 'fakturnia-shared';
import { DbClient } from 'fakturnia-shared';
import { DbDocument } from 'fakturnia-shared';
import { InvoiceGenerator } from 'fakturnia-shared';
import { FakturaVAT } from 'fakturnia-shared';
import { IBankAccount } from 'fakturnia-shared';
import { KsefClientValidatorUtils } from 'shared/utils/ksef-client-validator.utils';
import { APIResponse, TemplateUtils, Settings, Product, Utils, calculateAdvancePaymentTaxBreakdown, toOrderProduct, VatRateUtils, DocumentHelper, GroupedTaxSum, CompanyFieldsUtils } from 'fakturnia-shared';
import { UserSettings } from "fakturnia-shared";
import { DocumentsApiService } from 'shared/services/api/documents.api.service';
import { NgxSeoService } from 'shared/modules/ngx-seo/ngx-seo.service';
import { ClientsService } from 'shared/services/clients.service';
import { SnackbarService } from 'shared/services/snackbar.service';
import { NBPApiService } from 'shared/services/api/nbp.api.service';
import { DateTime } from 'luxon';
import { DecimalFormatterDirective } from 'shared/directives/decimal-formatter.directive';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SelectClientControlComponent } from 'shared/components/select-client-control/select-client-control.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxExtendedPdfViewerComponent, NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductsApiService } from 'shared/services/api/products.api.service';
import { QuantityDirective } from 'shared/directives/quantity.directive';
import { AutocompleteDirective } from 'shared/directives/autocomplete.directive';
import { SelectDropdownComponent } from 'shared/components/select-dropdown/select-dropdown.component';
import { BankAccountFormatDirective } from 'shared/directives/bank-accont-format.directive';
import { MatNativeDateModule } from '@angular/material/core';
import { InvoicesService } from 'shared/services/invoices.service';
import { IntegerOnlyDirective } from 'shared/directives/integer-only.directive';
import { ClearOnFocusDirective } from 'shared/directives/clear-on-focus.directive';
import { ExchangeRateDirective } from 'shared/directives/exchange-rate.directive';
import { AutocompleteSettingsComponent } from 'app/account/settings/autocomplete-settings/autocomplete-settings.component';
import { AutocompleteSettingsDialogComponent } from 'shared/dialogs/autocomplete-settings-dialog/autocomplete-settings-dialog.component';
import { LogoUtils } from 'shared/utils/logo.utils';
import { settings } from 'environments/environment';
import { AnnotationsCardComponent } from 'shared/components/annotations-card/annotations-card.component';
import { SchemeService } from 'shared/services/scheme.service';
import { OrderProductsTableComponent } from 'shared/components/order-products-table/order-products-table.component';

const materialModules = [
  MatTooltipModule,
  MatIconModule,
  MatButtonModule,
  MatMenuModule,
  MatListModule,
  MatChipsModule,
  MatSidenavModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatAutocompleteModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatCheckboxModule,
  MatRadioModule,
  MatSnackBarModule,
  MatDatepickerModule,
  MatNativeDateModule,
  RouterModule
]

@Component({
  standalone: true,
  selector: 'app-issue',
  imports: [CommonModule, IntegerOnlyDirective, DecimalFormatterDirective, ClearOnFocusDirective, ExchangeRateDirective, SelectDropdownComponent, BankAccountFormatDirective, AutocompleteDirective, QuantityDirective, FormsModule, ReactiveFormsModule, SelectClientControlComponent, NgxExtendedPdfViewerModule, AnnotationsCardComponent, OrderProductsTableComponent, materialModules],
  templateUrl: './issue.component.html',
  styleUrls: ['./issue.component.scss']
})
export class IssueComponent implements AfterViewInit, OnInit, OnDestroy {

  @ViewChild(AnnotationsCardComponent) annotationsCard: AnnotationsCardComponent | undefined;

  subscriptions: Subscription[] = [];

  public currencies = AppData.Currencies

  public isPdfLoaded: boolean | null = null
  public pdfBackgroundColor = '#d8d8d8'
  measurementUnits = AppData.MeasurementUnits;
  vatRates: any = AppData.DefaultVatRates;
  additionalDateHeaders = AppData.AdditionalDateHeaders;
  
  /** Lista metod płatności do wyboru (uproszczona + ewentualnie legacy) */
  paymentMethods = [...AppData.PaymentMethodsSimplified];
  
  paymentStatuses = AppData.PaymentStatuses;
  paymentDateHeaders = AppData.PaymentDateHeaders.map(x => x.name)
  subheaderDateHeaders = AppData.AdditionalDateHeaders.map(x => x.name)
  documents: DbDocumentObject
  document: any = new FakturaVAT();

  tableHeaders = this.document.table.headers;

  invoice: Invoice = new Invoice();
  settings: Settings;

  isAuthenticated = false;

  loadingStatus = new BehaviorSubject<{ isDataLoaded: boolean, isDocumentLoaded: boolean, areSettingsLoaded: boolean }>({ isDataLoaded: false, isDocumentLoaded: false, areSettingsLoaded: false });
  currentLoadingStatus = this.loadingStatus.asObservable();

  bankAccounts: IBankAccount[] = []

  generalFieldsToShow = new Set<string>()
  products: DbProduct[] = []
  isLoaded = false

  gtu = AppData.GTU

  mode: 'edit' | 'create' = 'create'

  /** Klucz localStorage do trwałego zapamiętania zwinięcia ostrzeżenia o KSeF dla typu "Faktura" */
  private static readonly FAKTURA_KSEF_WARNING_KEY = 'fakturnia_faktura_ksef_warning_collapsed';

  /** Czy ostrzeżenie KSeF dla typu "Faktura" jest zwinięte (stan zapisywany w localStorage) */
  public isFakturaKsefWarningCollapsed: boolean =
    localStorage.getItem('fakturnia_faktura_ksef_warning_collapsed') === 'true';

  /** Przełącza widoczność ostrzeżenia KSeF i zapisuje stan w localStorage */
  public toggleFakturaKsefWarning(): void {
    this.isFakturaKsefWarningCollapsed = !this.isFakturaKsefWarningCollapsed;
    localStorage.setItem(IssueComponent.FAKTURA_KSEF_WARNING_KEY, String(this.isFakturaKsefWarningCollapsed));
  }

  // Tryb wprowadzania cen (netto/brutto)
  priceInputMode: PriceInputMode = PriceInputMode.NETTO;

  marginProcedures = [
    // { id: null, text: 'Nie wybrano'},
    ...AppData.MarginProcedures
  ]

  // FakturaMPP jest deprecated - używaj adnotacji isSplitPayment
  // FakturaMPP pozostaje tylko dla wstecznej kompatybilności w trybie edycji
  // ksefSupported: true = dokument można wysłać do KSeF
  // FakturaKoncowa deprecated - zastąpiona przez FakturaRozliczeniowa (ale wspólna numeracja)
  private _allDocs = [
    { id: 'Zamowienie', name: 'Zamówienie' },
    { id: 'Faktura', name: 'Faktura', ksefSupported: false },
    { id: 'FakturaVAT', name: 'Faktura VAT', ksefSupported: true },
    { id: 'FakturaProforma', name: 'Faktura proforma' },
    { id: 'FakturaZaliczka', name: 'Faktura zaliczkowa', ksefSupported: true },
    { id: 'FakturaRozliczeniowa', name: 'Faktura rozliczeniowa', ksefSupported: true },
    { id: 'FakturaKoncowa', name: 'Faktura końcowa', deprecated: true, ksefSupported: true },
    { id: 'FakturaKorygujaca', name: 'Faktura korygująca', ksefSupported: true },
    { id: 'FakturaKorygujacaZaliczkowa', name: 'Faktura korygująca zaliczkową', ksefSupported: true },
    { id: 'FakturaKorygujacaRozliczeniowa', name: 'Faktura korygująca rozliczeniową', ksefSupported: true },
    { id: 'FakturaVATMarza', name: 'Faktura VAT marża', deprecated: true, ksefSupported: true },
    { id: 'FakturaVATMarzaProforma', name: 'Faktura VAT marża proforma',deprecated: true,  },
    { id: 'FakturaMPP', name: 'Faktura MPP (mechanizm podzielonej płatności)', deprecated: true, ksefSupported: true },
    { id: 'FakturaProformaBezVAT', name: 'Faktura proforma (bez vat)' },
    { id: 'FakturaWDT', name: 'Faktura WDT (wewnątrzwspólnotowa dostawa towarów)', deprecated: true,  ksefSupported: true },
  ]

  /** Dostępne typy dokumentów - FakturaMPP tylko w trybie edycji */
  get availableDocs() {
    if (this.mode === 'edit') {
      return this._allDocs;
    }
    // W trybie create ukryj deprecated i hidden typy
    return this._allDocs.filter(d => !(d as any).deprecated && !(d as any).hidden);
  }

  expenseDocumentTypes = [

  ]

  bankAccountIsDiffrentThanInSettings = false
  showPdfOverlay = false;

  // sellerFieldsToShow = []
  // buyerFieldsToShow = []
  // receiverFieldsToShow = []

  rows: number = 1; // Document name textarea, default for medium screens

  public toCorrectInvoiceId = null
  public similarDocumentId = null
  // Status płatności skopiowany z oryginału przy "wystaw podobny" (null = brak, użyj domyślnego)
  private _similarPaymentStatus: 0 | 1 | null = null
  /** ID zamówienia do którego wystawiamy fakturę zaliczkową */
  public advanceForOrderId: string | null = null
  /** ID faktury zaliczkowej dla której wystawiamy fakturę rozliczeniową */
  public settlementForAdvanceId: string | null = null
  public defaultVisibleSellerFields: string[] = []

  formatInfo: any = null

  isInvoiceNameAvailable = true
  /** ID dokumentu który ma taki sam numer (dla komunikatu o duplikacie) */
  duplicateDocumentId: string | null = null

  numberingType: NumberingTypes = NumberingTypes.MONTH

  userSettings: UserSettings

  public pagesCount = 1

  logo: { base64: string, width: number, height: number} | null = null

  // === FakturaZaliczka - wybór zamówienia ===
  /** Lista zamówień użytkownika dostępnych do powiązania */
  availableOrders: DbDocument[] = [];
  /** Wybrane zamówienie dla FakturaZaliczka */
  selectedOrder: DbDocument | null = null;
  /** Kwota zaliczki brutto */
  advancePaymentAmount: number = 0;
  /** Obliczony rozkład zaliczki na stawki VAT */
  advancePaymentTaxBreakdown: Array<{
    vatRate: string;
    netValue: number;
    vatValue: number;
    grossValue: number;
  }> = [];

  // === FakturaRozliczeniowa - wybór faktur zaliczkowych ===
  /** Lista faktur zaliczkowych dostępnych do powiązania */
  availableAdvanceInvoices: DbDocument[] = [];
  /** Wybrane faktury zaliczkowe dla FakturaRozliczeniowa */
  selectedAdvanceInvoices: DbDocument[] = [];
  /** Suma wartości wybranych faktur zaliczkowych */
  selectedAdvanceInvoicesSum: number = 0;
  /** Kwota rozliczenia - kwota pozostała do zapłaty (edytowalna przez użytkownika) */
  settlementAmount: number = 0;
  /** Czy kwota rozliczenia została ręcznie zmieniona przez użytkownika */
  isSettlementAmountManual: boolean = false;

  // === KOR_ZAL - korekta faktury zaliczkowej ===
  /** Czy edytujemy korektę faktury zaliczkowej (dedykowany typ dokumentu) */
  get isCorrectionOfAdvancePayment(): boolean {
    return this.invoice?.documentType === 'FakturaKorygujacaZaliczkowa';
  }

  /** Czy aktualnie edytujemy fakturę korygującą (dowolnego typu) */
  get isCorrectionInvoice(): boolean {
    return [
      'FakturaKorygujaca',
      'FakturaKorygujacaZaliczkowa',
      'FakturaKorygujacaRozliczeniowa'
    ].includes(this.invoice?.documentType);
  }

  /**
   * Sprawdza czy cena jednostkowa pozycji (netto lub brutto - w zależności od trybu) jest nieprawidłowa
   * z punktu widzenia KSeF / poprawności dokumentu.
   *
   * Zwraca `true` gdy:
   *  - cena nie jest ustawiona (null / undefined),
   *  - nie jest skończoną liczbą (NaN, Infinity),
   *  - jest ujemna,
   *  - po zaokrągleniu do 2 miejsc po przecinku daje 0.00 (KSeF wymaga CenaJedn > 0).
   */
  isPositionUnitPriceInvalidForKsef(p: any): boolean {
    if (!p) return false;
    const rawPrice = this.priceInputMode === 'brutto'
      ? p.getGrossPrice?.()
      : p.netPrice;

    // Brak ustawionej ceny traktujemy jako błąd (KSeF wymaga CenaJedn).
    if (rawPrice === null || rawPrice === undefined) return true;

    const price = Number(rawPrice);
    if (!Number.isFinite(price)) return true;

    // Wszystko, co po zaokrągleniu do 2 miejsc po przecinku daje 0.00 lub mniej.
    const ROUNDING_EPSILON = 0.005; // < 0.005 zaokrągla się do 0.00
    return price < ROUNDING_EPSILON;
  }

  /** Komunikat ostrzeżenia dla pozycji z nieprawidłową ceną (różny dla korekt vs. innych dokumentów) */
  getInvalidPriceWarning(): string {
    const priceLabel = this.priceInputMode === 'brutto' ? 'brutto' : 'netto';
    if (this.isCorrectionInvoice) {
      return `Cena ${priceLabel} pozycji wynosi 0. Faktur korygujących nie zeruje się przez wyzerowanie ceny — ` +
        `KSeF wymaga, aby zerowanie pozycji odbywało się przez ustawienie ilości na 0, a cenę pozostawić ` +
        `taką jak na fakturze korygowanej.`;
    }
    return `Cena ${priceLabel} pozycji wynosi 0. Sprawdź, czy została wprowadzona prawidłowo.`;
  }
  /** Zamówienie przed korektą (read-only, z oryginalnej faktury) */
  correctionOrderBefore: { invoiceName: string; grossSum: number; products: any[] } | null = null;
  // Produkty zamówienia po korekcie = invoice.products (używamy standardowych pozycji dokumentu)
  /** Kwota zaliczki przed korektą (read-only) */
  correctionAdvanceAmountBefore = 0;
  /** Kwota zaliczki po korekcie (edytowalna) */
  correctionAdvanceAmountAfter = 0;
  /** Rozkład VAT korekty (różnica przed/po) */
  correctionAdvanceTaxBreakdown: Array<{
    vatRate: string;
    netValue: number;
    vatValue: number;
    grossValue: number;
  }> = [];
  
  // === KOR_ROZ - korekta faktury rozliczeniowej ===
  /** Czy edytujemy korektę faktury rozliczeniowej */
  get isCorrectionOfSettlementInvoice(): boolean {
    return this.invoice?.documentType === 'FakturaKorygujacaRozliczeniowa';
  }
  /** Kwota pozostała do zapłaty PRZED korektą (read-only) */
  correctionSettlementAmountBefore = 0;
  /** Kwota pozostała do zapłaty PO korekcie (edytowalna) */
  correctionSettlementAmountAfter = 0;
  /** Powiązane faktury zaliczkowe dla KOR_ROZ (edytowalne) */
  correctionLinkedAdvanceInvoices: DbDocument[] = [];

  /** Czy tryb samofakturowania jest aktywny */
  isSelfInvoicingMode = false;
  /** Czy ustawienie JST jest włączone (Jednostka Samorządu Terytorialnego) */
  enableJst = false;
  /** Przechowuje oryginalne dane sellera (użytkownika) do przywrócenia po wyłączeniu samofakturowania */
  private _originalSellerData: Company | null = null;

  /**
   * Sprawdza czy limit dokumentów w abonamencie został przekroczony
   * Zwraca zawsze false gdy subskrypcje są wyłączone (settings.enableSubscriptions = false)
   */
  get isDocumentLimitExceeded(): boolean {
    // Gdy subskrypcje wyłączone - nigdy nie pokazuj alertu o limicie
    if (!settings.enableSubscriptions) return false;
    
    if (!this.userSettings) return false;
    
    const documentsCreatedThisMonth = (this.userSettings as any)?.stats?.documentsCreatedThisMonth || 0;
    const documentLimit = this._getDocumentLimit();
    
    // null = bez limitu
    if (documentLimit === null) return false;
    
    return documentsCreatedThisMonth >= documentLimit;
  }

  /**
   * Pobiera efektywny limit dokumentów z backendu
   */
  private _getDocumentLimit(): number | null {
    const stats = (this.userSettings as any)?.stats;
    if (stats && stats.effectiveDocumentLimit !== undefined) {
      return stats.effectiveDocumentLimit;
    }
    return null;
  }

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private _productsService: ProductsService,
    private _documentsService: DocumentsService,
    private _settingsService: SettingsService,
    private _dialogService: DialogService,
    private seo: NgxSeoService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private _synchronizationService: SynchronizationService,
    private _dataSynchronizerService: DataSynchronizerService,
    private _invoicePreviewService: InvoicePreviewService,
    private _invoicesService: InvoicesService,
    private _toastService: ToastService,
    private _bankAccountApiService: BankAccountsApiService,
    private _documentsApiService: DocumentsApiService,
    private _clientsService: ClientsService,
    private _snackbarService: SnackbarService,
    private _nbpApiService: NBPApiService,
    private _productsApiService: ProductsApiService,
    private _dialog: MatDialog,
    private _schemeService: SchemeService
  ) {

    this.checkInvoiceName = debounce(this.checkInvoiceName, 10)

    this.subscriptions.push(
      this._schemeService.currentScheme.subscribe((scheme: string) => {
        this.pdfBackgroundColor = scheme === 'dark' ? '#4a5060' : '#d8d8d8';
      })
    );
  }

  ngOnInit(): void {

    this.subscriptions.push(
      this._settingsService.currentUserSettings.subscribe({
        next: async (userSettings: UserSettings) => {

          this.userSettings = userSettings

          this.logo = ObjectUtils.getNestedValue(this.userSettings, 'company.logo')
         
          

          if (this.mode != 'create') return

          // Set numbering format
          this._setNumberingFormat()

          // Set numbering type
          this._setNumberingType()

          // Set numbering type
          this._setSymbol()

        }
      })
    )

    this.subscriptions.push(
      combineLatest({
        params: this.route.params,
        queryParams: this.route.queryParams,
        userSettings: this._settingsService.getUserSettings()
      })
        .subscribe({
          next: (data) => {

            const params: any = data.params
            const queryParams: any = data.queryParams

            this.userSettings = data.userSettings
            if (Utils.isDefined(queryParams, "toCorrectInvoiceId")) {
              this.toCorrectInvoiceId = queryParams.toCorrectInvoiceId
            }
            if (Utils.isDefined(queryParams, "similarDocumentId")) {
              this.similarDocumentId = queryParams.similarDocumentId
            }
            if (Utils.isDefined(queryParams, "advanceForOrderId")) {
              this.advanceForOrderId = queryParams.advanceForOrderId
            }
            if (Utils.isDefined(queryParams, "settlementForAdvanceId")) {
              this.settlementForAdvanceId = queryParams.settlementForAdvanceId
            }
            // Nowy format: orderId + type=zal
            if (Utils.isDefined(queryParams, "orderId") && queryParams.type === 'zal') {
              this.advanceForOrderId = queryParams.orderId
            }

            this.bankAccounts = data.userSettings.bankAccounts
            this.settings = data.userSettings.settings;
            this.defaultVisibleSellerFields = this.settings.defaultVisibleSellerFields || []
            if (typeof this.settings != 'string') {
              // Normalizacja stawek VAT z ustawień (mogą być string lub number)
              const normalizedUserVatRates = this.settings.vatRates.map((x: any) => {
                if (VatRateUtils.isNumberVatRate(x)) return parseFloat(x);
                // Normalizacja legacy stawek: 0 → '0 KR', 'np' → 'np I'
                return VatRateUtils.normalizeLegacyVatRate(x);
              });
              this.vatRates = AppData.VatRates.filter((rate: any) => 
                normalizedUserVatRates.includes(rate.value)
              );
            }

            if (ObjectUtils.isDefined(data, "userSettings.settings.defaultTaxRate")) {
              const defaultTaxRate = ObjectUtils.getNestedValue(data, "userSettings.settings.defaultTaxRate")
              this.defaultTaxRate = defaultTaxRate
            }

            this.checkVatRates();

            if (Utils.isNullOrEmpty(this.settings?.autocomplete?.issuePlace)) {
              this.generalFieldsToShow.add('issuePlace')
            }

            if (!Utils.isNullOrEmpty(this.settings?.autocomplete?.signatures) && this.settings?.autocomplete?.signatures) {
              this.generalFieldsToShow.add('signatures')
            }

            if (typeof params.id == 'undefined') return

            // Creating brand new document
            if (params.id == 'wystaw') {
              if (!this.isLoaded) {
                this.mode = 'create'
                this.isLoaded = true
                // Resetuj listę metod płatności do uproszczonej (bez legacy)
                this.paymentMethods = [...AppData.PaymentMethodsSimplified];
                this.newDocument(data.userSettings)
                this.setNextDocumentName();
              }

              // Issue invoice for clientId
              if (typeof queryParams.clientId !== 'undefined') {
                const client = this._clientsService.getById(queryParams.clientId)
                if (!client) {
                  this._snackbarService.showSnackBar('Nie znaleziono klienta o wskazanym identyfikatorze.', 'error')
                  return
                }

                this.updateBuyer(client)

              }

              // Wystaw fakturę zaliczkową dla zamówienia
              if (this.advanceForOrderId) {
                this._initAdvanceInvoiceFromOrder(this.advanceForOrderId)
              }

              // Wystaw fakturę rozliczeniową dla faktury zaliczkowej
              if (this.settlementForAdvanceId) {
                this._initSettlementInvoiceFromAdvance(this.settlementForAdvanceId)
              }
            }


            // Editing document
            else {
              this.mode = 'edit'
              this.isLoaded = true
              // Resetuj listę metod płatności do uproszczonej (legacy zostanie dodane w addLegacyPaymentMethodIfNeeded)
              this.paymentMethods = [...AppData.PaymentMethodsSimplified];
              this.invoice = this.loadDocument(params.id)

              // Sprawdź czy dokument jest edytowalny (np. nie wysłany do KSeF, nie zaimportowany z KSeF)
              if (!DocumentHelper.canEdit(this.invoice as any)) {
                this._snackbarService.showSnackBar('Ten dokument nie może być edytowany.', 'warning', 5000)
                this.router.navigateByUrl('/konto/dokumenty')
                return
              }

              if (this.invoice.numberingFormat == null) {
                this._snackbarService.showSnackBar('Tego dokumentu nie można edytować. Jeśli zawiera błędy, prosimy o wystawienie nowego.', 'warning', 8000)
                this.router.navigateByUrl('/konto/dokumenty/' + this.invoice._id + '/podglad')
                return
              }

              // === Zamówienie - sprawdź czy ma powiązane faktury zaliczkowe ===
              if (this.invoice.documentType === 'Zamowienie') {
                const allDocs = this._documentsService.getAllDocumentsSync();
                const linkedAdvanceInvoices = allDocs.filter(
                  doc => doc.documentType === 'FakturaZaliczka' && 
                    (doc as any).linkedOrderId === this.invoice._id &&
                    !doc.isDeleted
                );
                if (linkedAdvanceInvoices.length > 0) {
                  const invoiceNames = linkedAdvanceInvoices.map(inv => inv.invoiceName || inv.documentNumber).join(', ');
                  this._snackbarService.showSnackBar(
                    `To zamówienie ma powiązane faktury zaliczkowe (${invoiceNames}) i nie może być edytowane.`,
                    'warning',
                    8000
                  );
                  this.router.navigateByUrl('/konto/dokumenty/' + this.invoice._id + '/podglad');
                  return;
                }
              }

              // this.buyerFieldsToShow = this.invoice.buyer.fieldsToShow
              // this.sellerFieldsToShow = this.invoice.seller.fieldsToShow
              // this.receiverFieldsToShow = this.invoice.receiver.fieldsToShow
              this.formatInfo = AppData.DocumentNumberFormats.find(x => x.format == this.invoice.numberingFormat)

              if (this.invoice.prepaymentIds.length > 0) {
                this.invoice.prepayments = []
                this.invoice.prepaymentIds.forEach(prepaymentId => {
                  const prepayment = this._documentsService.getById(prepaymentId)
                  if (prepayment) this.invoice.addPrepayment(prepayment)
                })
              }

              if (!Utils.isNullOrEmpty(this.invoice.correctedInvoiceId)) {
                this.invoice.correctedInvoice = null
                const correctedInvoice = this._documentsService.getById(this.invoice.correctedInvoiceId)
                if (correctedInvoice) this.invoice.addCorrectedInvoice(correctedInvoice, false)
              }

              // === FakturaZaliczka - załaduj powiązane zamówienie i kwotę zaliczki ===
              if (this.invoice.documentType === 'FakturaZaliczka' && this.invoice.linkedOrderId) {
                // Załaduj zamówienia do listy
                this.loadAvailableOrders();
                
                // Ustaw kwotę zaliczki
                this.advancePaymentAmount = this.invoice.advancePaymentAmount || 0;
                
                // Ustaw rozkład VAT
                this.advancePaymentTaxBreakdown = this.invoice.advancePaymentTaxBreakdown || [];
                
                // Znajdź i ustaw zamówienie
                const linkedOrder = this._documentsService.getById(this.invoice.linkedOrderId);
                if (linkedOrder) {
                  this.selectedOrder = linkedOrder;
                  // Ustaw linkedOrder na invoice (jeśli nie jest już ustawione)
                  if (!this.invoice.linkedOrder) {
                    const orderProducts = (linkedOrder.products || []).map((p: any) => ({
                      name: p.name || '',
                      unitOfMeasure: p.unitOfMeasure || 'szt.',
                      quantity: p.quantity || 1,
                      netPrice: p.netPrice || 0,
                      netValue: p.netValue || 0,
                      vatRate: p.vatRate ?? 23,
                      amountOfVat: p.amountOfVat || 0,
                      grossValue: p.grossValue || 0
                    }));
                    this.invoice.linkedOrder = {
                      invoiceName: linkedOrder.invoiceName || linkedOrder.documentNumber || 'Zamówienie',
                      grossSum: linkedOrder.grossSum || 0,
                      products: orderProducts
                    };
                  }
                }
              }

              // === FakturaRozliczeniowa - załaduj powiązane faktury zaliczkowe ===
              if (this.invoice.documentType === 'FakturaRozliczeniowa') {
                // Ustaw kwotę rozliczenia
                this.settlementAmount = this.invoice.settlementAmount || 0;
                
                // Ustaw flagę ręcznej edycji z modelu
                this.isSettlementAmountManual = this.invoice.isSettlementAmountManual || false;
                
                // Rozkład VAT jest teraz obliczany automatycznie w count()
                
                // Załaduj powiązane faktury zaliczkowe
                if (this.invoice.linkedAdvanceInvoiceIds && this.invoice.linkedAdvanceInvoiceIds.length > 0) {
                  this.selectedAdvanceInvoices = [];
                  this.invoice.linkedAdvanceInvoiceIds.forEach(id => {
                    const advanceInvoice = this._documentsService.getById(id);
                    if (advanceInvoice) {
                      this.selectedAdvanceInvoices.push(advanceInvoice);
                    }
                  });
                  
                  // Oblicz sumę faktur zaliczkowych
                  this.selectedAdvanceInvoicesSum = this.selectedAdvanceInvoices.reduce(
                    (sum, inv) => sum + (inv.grossSum || 0), 0
                  );
                  
                  // Ustaw linkedAdvanceInvoices na invoice jeśli nie jest już ustawione
                  if (!this.invoice.linkedAdvanceInvoices || this.invoice.linkedAdvanceInvoices.length === 0) {
                    this.invoice.linkedAdvanceInvoices = this.selectedAdvanceInvoices.map(inv => ({
                      _id: inv._id,
                      invoiceName: inv.invoiceName || inv.documentNumber || '',
                      documentNumber: inv.documentNumber,
                      grossSum: inv.grossSum || 0,
                      ksefNumber: (inv as any).ksefNumber
                    }));
                  }
                }
              }

              // === KOR_ZAL - załaduj dane korekty faktury zaliczkowej ===
              if (this.invoice.documentType === 'FakturaKorygujacaZaliczkowa' && this.invoice.correctionOrderBefore) {
                this.correctionOrderBefore = this.invoice.correctionOrderBefore;
                this.correctionAdvanceAmountBefore = this.invoice.correctionAdvanceAmountBefore || 0;
                this.correctionAdvanceAmountAfter = this.invoice.correctionAdvanceAmountAfter || 0;
                this.correctionAdvanceTaxBreakdown = this.invoice.correctionAdvanceTaxBreakdown || [];
                // Produkty zamówienia po korekcie są w invoice.products (z DB)
                // Parent jest już ustawiony przez fromDbDocument → addProducts
              }

              // === KOR_ROZ - załaduj dane korekty faktury rozliczeniowej ===
              if (this.invoice.documentType === 'FakturaKorygujacaRozliczeniowa') {
                this.correctionSettlementAmountBefore = this.invoice.correctionSettlementAmountBefore || 0;
                this.correctionSettlementAmountAfter = this.invoice.correctionSettlementAmountAfter || 0;
                // correctionSettlementTaxBreakdown jest obliczany w count()

                // Załaduj powiązane faktury zaliczkowe z dokumentu
                if (this.invoice.linkedAdvanceInvoiceIds && this.invoice.linkedAdvanceInvoiceIds.length > 0) {
                  this.correctionLinkedAdvanceInvoices = [];
                  this.invoice.linkedAdvanceInvoiceIds.forEach(id => {
                    const advanceInvoice = this._documentsService.getById(id);
                    if (advanceInvoice) {
                      this.correctionLinkedAdvanceInvoices.push(advanceInvoice);
                    }
                  });
                  // Ustaw linkedAdvanceInvoices na invoice jeśli nie jest już ustawione
                  if (!this.invoice.linkedAdvanceInvoices || this.invoice.linkedAdvanceInvoices.length === 0) {
                    this.invoice.linkedAdvanceInvoices = this.correctionLinkedAdvanceInvoices.map(inv => ({
                      _id: inv._id,
                      invoiceName: inv.invoiceName || inv.documentNumber || '',
                      documentNumber: inv.documentNumber,
                      grossSum: inv.grossSum || 0,
                      ksefNumber: (inv as any).ksefNumber
                    }));
                  }
                } else if (this.invoice.linkedAdvanceInvoices && this.invoice.linkedAdvanceInvoices.length > 0) {
                  // Fallback: jeśli mamy linkedAdvanceInvoices ale nie IDs (np. stare dokumenty)
                  this.correctionLinkedAdvanceInvoices = this.invoice.linkedAdvanceInvoices.map(adv => ({
                    _id: adv._id,
                    invoiceName: adv.invoiceName,
                    documentNumber: adv.documentNumber,
                    grossSum: adv.grossSum,
                    ksefNumber: adv.ksefNumber
                  } as any));
                }
              }

              if (this.invoice.hasReceiver) {
                this.generalFieldsToShow.add('hasReceiver')
              }

              if (this.invoice.hasComments) {
                this.generalFieldsToShow.add('hasComments')
              }

              if (this.invoice.hasGTU) {
                this.generalFieldsToShow.add('hasGTU')
              }

              if (this.invoice.hasPKWiU) {
                this.generalFieldsToShow.add('hasPKWiU')
              }

              // Ustaw showPKWiU z ustawień użytkownika, jeśli nie jest w dokumencie
              if (this.invoice.showPKWiU === undefined && Utils.isDefined(data.userSettings, "settings.autocomplete.showPKWiU")) {
                this.invoice.showPKWiU = data.userSettings.settings.autocomplete.showPKWiU !== undefined ? data.userSettings.settings.autocomplete.showPKWiU : true;
              }

              // Dodaj showPKWiU do generalFieldsToShow jeśli jest włączone
              if (this.invoice.showPKWiU) {
                this.generalFieldsToShow.add('showPKWiU')
              }

              this.syncVatExemptionSource();

              // Tryb wprowadzania cen (netto/brutto) — w edycji też czytaj z ustawień
              if (Utils.isDefined(data.userSettings, "settings.autocomplete.priceInputMode")) {
                this.priceInputMode = data.userSettings.settings.autocomplete.priceInputMode || PriceInputMode.NETTO;
              }

              // JST — w edycji czytaj z ustawień użytkownika
              if (Utils.isDefined(data.userSettings, "settings.general.enableJst") && data.userSettings.settings.general?.enableJst === true) {
                this.enableJst = true;
              }

              if (this.invoice.hasDiscount) {
                this.generalFieldsToShow.add('hasDiscount')
              }

              if (this.invoice.additionalPaymentDateHeader.show) {
                this.generalFieldsToShow.add('hasAdditionalPaymentDate')
              }

              if (this.invoice.hasPaymentDescription) {
                this.generalFieldsToShow.add('hasPaymentDescription')
              }

              // Dodaj legacy metodę płatności jeśli dokument ma metodę której nie ma w uproszczonej liście
              this.addLegacyPaymentMethodIfNeeded();

              if (this.invoice.signatures.issuerSignature.show == false || this.invoice.signatures.receiverSignature.show == false) {
                this.generalFieldsToShow.delete('signatures')
              }
              
              // === Samofakturowanie - ustaw tryb jeśli dokument ma annotations.isSelfInvoicing ===
              if (this.invoice.annotations?.isSelfInvoicing) {
                this.isSelfInvoicingMode = true;
                // Zapisz dane buyera (użytkownika) jako oryginalne dane sellera
                // przy samofakturowaniu buyer = użytkownik, seller = kontrahent
                this._originalSellerData = new Company(this.invoice.buyer);
              }

              this.checkBankAccounts()
              this.seo.setTitle(this.invoice.invoiceName + ' - Fakturnia.pl')
              this.setDocumentType(this.invoice.documentType)
              this.checkVatRates();

              this.invoice.count()
            }

            this.removeInvoiceObserver()
            this.addInvoiceObserver()
            this.renderPreview()

          }
        })
    )

    this.subscriptions.push(this.authService.isLoggedIn$.subscribe({
      next: (data) => {
        this.isAuthenticated = data
      }
    }))

  }

  ngAfterViewInit(): void {
    this.addInvoiceObserver()
  }

  ngOnDestroy(): void {
    this.removeInvoiceObserver()
    this.invoice.prepaymentIds = []

    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  public onPdfLoaded(ev) {
    this.isPdfLoaded = true
  }


  public onPagesLoaded(ev) {
    this.pagesCount = ev.pagesCount
  }

  /**
   * Dodaje legacy metodę płatności do listy wyboru jeśli dokument ma metodę
   * której nie ma w uproszczonej liście (PaymentMethodsSimplified).
   * Pozwala to wyświetlić starą metodę płatności w kontrolce podczas edycji,
   * ale nie dodaje wszystkich starych metod do wyboru.
   */
  private addLegacyPaymentMethodIfNeeded(): void {
    const currentPaymentMethodIndex = this.invoice.paymentMethod?.value;
    
    // Sprawdź czy aktualna metoda płatności jest w uproszczonej liście
    const isInSimplifiedList = this.paymentMethods.some(pm => pm.index === currentPaymentMethodIndex);
    
    if (!isInSimplifiedList && currentPaymentMethodIndex !== null && currentPaymentMethodIndex !== undefined) {
      // Znajdź metodę płatności w pełnej liście (legacy)
      const legacyMethod = AppData.PaymentMethods.find(pm => pm.index === currentPaymentMethodIndex);
      
      if (legacyMethod) {
        // Dodaj legacy metodę na początek listy z oznaczeniem
        this.paymentMethods = [
          { ...legacyMethod, name: `${legacyMethod.name} (legacy)` },
          ...this.paymentMethods
        ];
      }
    }
  }

  loadDocument(documentId): Invoice {
    const document = this._documentsService.getById(documentId)
    if (!document || typeof document == 'undefined') {
      console.warn("[IssueComponent]: Document not found.")
      this.router.navigateByUrl('/konto/dokumenty')
      return new Invoice()
    }

    return new Invoice().fromDbDocument(cloneDeep(document))
  }

  showUpdateSellerDialog() {
    this.showCreateOrUpdateClientDialog(this.invoice.seller, 'seller')
  }

  showCreateOrUpdateClientDialog(client, type: 'seller' | 'buyer' | 'receiver') {
    this.subscriptions.push(this._dialogService.showCreateOrUpdateClientDialog(client, type)
      .subscribe({
        next: (data) => {


          if (data == null) return
          if (data.success != true) return

          this.invoice[type].fieldsToShow = data.client.fieldsToShow

          if (type == 'seller') {
            this.updateSeller(data.client)
          }
          else if (type == 'buyer') {
            this.updateBuyer(data.client)
          }
          else if (type == 'receiver') {
            this.updateReceiver(data.client)
          }

          this.renderPreview()
        }
      }))
  }



  showToggleFormFieldsDialog() {
    // Upewnij się, że showVatExemptionBase jest w generalFieldsToShow jeśli jest włączone w invoice
    if (this.invoice['showVatExemptionBase']) {
      this.generalFieldsToShow.add('showVatExemptionBase');
    } else {
      this.generalFieldsToShow.delete('showVatExemptionBase');
    }

    // Upewnij się, że showPKWiU jest w generalFieldsToShow jeśli jest włączone w invoice
    if (this.invoice.showPKWiU) {
      this.generalFieldsToShow.add('showPKWiU');
    } else {
      this.generalFieldsToShow.delete('showPKWiU');
    }

    // Upewnij się, że showKsefQrCode jest w generalFieldsToShow jeśli jest włączone w invoice
    if (this.invoice['showKsefQrCode']) {
      this.generalFieldsToShow.add('showKsefQrCode');
    } else {
      this.generalFieldsToShow.delete('showKsefQrCode');
    }

    // Upewnij się, że showConvertedAmount jest w generalFieldsToShow jeśli jest włączone w invoice
    if (this.invoice.showConvertedAmount) {
      this.generalFieldsToShow.add('showConvertedAmount');
    } else {
      this.generalFieldsToShow.delete('showConvertedAmount');
    }

    this._dialogService.showToggleFormFieldsDialog({
      currency: this.invoice.currency,
      generalFieldsToShow: Array.from(this.generalFieldsToShow),
      documentType: this.invoice.documentType
    }

    )
      .subscribe({
        next: (result) => {

          if (!result) return
          if (result.success !== true) return

          if (typeof result.data.dateHeader != 'undefined') {
            this.invoice.setSubHeader(result.data.dateHeader)
          }


          if (typeof result.data.generalFieldsToShow != 'undefined') {
            this.generalFieldsToShow = new Set(result.data.generalFieldsToShow)

            this.invoice.toggleSignatures(this.generalFieldsToShow.has('signatures'))
            this.invoice.hasReceiver = this.generalFieldsToShow.has('hasReceiver')
            this.invoice.hasComments = this.generalFieldsToShow.has('hasComments')
            this.invoice.hasGTU = this.generalFieldsToShow.has('hasGTU')
            this.invoice.hasPKWiU = this.generalFieldsToShow.has('hasPKWiU')
            this.invoice.hasDiscount = this.generalFieldsToShow.has('hasDiscount')
            this.invoice.hasPaymentDescription = this.generalFieldsToShow.has('hasPaymentDescription')
            this.invoice['showVatExemptionBase'] = this.generalFieldsToShow.has('showVatExemptionBase')
            this.invoice.setAdditionalPaymentDateShow(this.generalFieldsToShow.has('hasAdditionalPaymentDate'))
            
            // Update showPKWiU
            this.invoice.showPKWiU = this.generalFieldsToShow.has('showPKWiU')
            
            // Update showKsefQrCode
            this.invoice['showKsefQrCode'] = this.generalFieldsToShow.has('showKsefQrCode')

            // Update showConvertedAmount
            this.invoice.showConvertedAmount = this.generalFieldsToShow.has('showConvertedAmount')


            if (this.invoice.hasDiscount == false) {
              this.invoice.products.forEach(product => {
                product.setDiscount(0)
              })
            }
          }

          if (result.success === true) {
            this.renderPreview()
          }
        }
      })
  }

  defaultTaxRate = 23
  isCreating = false
  newDocument(userSettings: UserSettings) {

    if (this.isCreating) return
    this.isCreating = true

    this.invoice = new Invoice();
    this.invoice.setDocument(this.document);

    // Set numbering format
    this._setNumberingFormat()

    // Set numbering type
    this._setNumberingType()

    if (this.toCorrectInvoiceId) {
      let toCorrectInvoice = this._documentsService.getById(this.toCorrectInvoiceId)
      
      // Smart wybór typu korekty na podstawie typu korygowanego dokumentu
      let correctionType = 'FakturaKorygujaca';
      if (toCorrectInvoice) {
        if (toCorrectInvoice.documentType === 'FakturaZaliczka') {
          correctionType = 'FakturaKorygujacaZaliczkowa';
        } else if (toCorrectInvoice.documentType === 'FakturaRozliczeniowa' || toCorrectInvoice.documentType === 'FakturaKorygujacaRozliczeniowa') {
          correctionType = 'FakturaKorygujacaRozliczeniowa';
        } else if (toCorrectInvoice.documentType === 'FakturaKorygujacaZaliczkowa') {
          correctionType = 'FakturaKorygujacaZaliczkowa';
        }
      }

      this.document = TemplateUtils.GetDocumentById(correctionType)
      this.invoice.setDocument(this.document);
      
      if (toCorrectInvoice) {
        this.invoice.setBuyer(toCorrectInvoice.buyer)
        if (toCorrectInvoice.hasReceiver) this.invoice.setReceiver(toCorrectInvoice.receiver)
        this.invoice.addCorrectedInvoice(toCorrectInvoice)

        // Waluta korekty musi być taka sama jak faktury korygowanej
        this.invoice.currency = toCorrectInvoice.currency || 'PLN'
        this.invoice.exchangeRate = (toCorrectInvoice as any).exchangeRate || null

        // Sprawdź kurs waluty jeśli waluta inna niż PLN
        if (this.invoice.currency !== 'PLN') {
          this.checkExchangeRate()
        }

        // === KOR_ZAL - inicjalizacja danych korekty zaliczkowej ===
        if (correctionType === 'FakturaKorygujacaZaliczkowa' && toCorrectInvoice.documentType === 'FakturaZaliczka') {
          this._initCorrectionOfAdvancePayment(toCorrectInvoice);
        }

        // === KOR_ROZ - inicjalizacja danych korekty rozliczeniowej ===
        if (correctionType === 'FakturaKorygujacaRozliczeniowa') {
          this._initCorrectionOfSettlement(toCorrectInvoice);
        }
      }
    }

    if (this.similarDocumentId) {
      let similarDocument = this._documentsService.getById(this.similarDocumentId)
      if (similarDocument) {
        this.document = TemplateUtils.GetDocumentById(similarDocument.documentType)
        this.invoice.setDocument(this.document);
        this.invoice.setBuyer(similarDocument.buyer)
        const similarInvoice = new Invoice().fromDbDocument(similarDocument)
        if (similarDocument.hasDiscount == true) this.invoice.hasDiscount = true
        if (similarDocument.hasReceiver) this.invoice.setReceiver(similarDocument.receiver)
        this.invoice.addProducts(similarInvoice.products)
        this.invoice.annotations = cloneDeep(similarInvoice.annotations);
        this.invoice.additionalInfo = cloneDeep(similarInvoice.additionalInfo);
        // Kopiuj sposób płatności i zapamiętaj status płatności z oryginału (mniej klikania przy "wystaw podobny")
        this.invoice.setPaymentMethod(similarInvoice.paymentMethod.value);
        this.addLegacyPaymentMethodIfNeeded();
        this._similarPaymentStatus = similarInvoice.paymentStatus.value as 0 | 1;
        this.invoice['vatExemptionBase'] = similarInvoice['vatExemptionBase'];
        this.invoice['vatExemptionBaseCustom'] = similarInvoice['vatExemptionBaseCustom'];
        this.invoice['showVatExemptionBase'] = similarInvoice['showVatExemptionBase'];
        // Kopiuj bankAccountNumber z wartościami domyślnymi dla opcjonalnych pól
        this.invoice.bankAccountNumber = {
          show: similarDocument.bankAccountNumber.show,
          value: similarDocument.bankAccountNumber.value || '',
          text: similarDocument.bankAccountNumber.text || '',
          swift: similarDocument.bankAccountNumber.swift ?? '',
          bank: similarDocument.bankAccountNumber.bank ?? '',
          accountDescription: similarDocument.bankAccountNumber.accountDescription ?? '',
          bankOwnAccountType: similarDocument.bankAccountNumber.bankOwnAccountType ?? null
        }
      }
    }


    let defaultTaxRate = this.defaultTaxRate
    if (this.invoice.documentType == 'FakturaWDT') defaultTaxRate = 0

    if (this.invoice.products.length == 0) {
      this.invoice.addProducts([
        new Product(
          {
            _id: '',
            name: '',
            unitOfMeasure: 'szt.',
            quantity: 1,
            discount: 0,
            netPrice: 0,
            vatRate: defaultTaxRate,
            parent: this.invoice
          }
        )
      ])
    }

    if (!Utils.isNullOrEmpty(userSettings)) {

      this.invoice.seller = new Company({
        name: userSettings.company.name,
        firstName: userSettings.user.firstName,
        lastName: userSettings.user.lastName,
        pesel: userSettings.user.pesel,
        idNumber: userSettings.user.idNumber,
        type: userSettings.company.type,
        nip: userSettings.company.nip,
        vatUE: userSettings.company.vatUE,
        regon: userSettings.company.regon,
        bdo: userSettings.company.bdo,
        krs: userSettings.company.krs,
        phoneNumber: userSettings.user.phoneNumber,
        email: userSettings.user.emailAddress,
        fax: userSettings.company.fax,
        www: userSettings.company.www,
        street: userSettings.address.street,
        postalCode: userSettings.address.postalCode,
        city: userSettings.address.city,
        country: userSettings.address.country,
        countryCode: (userSettings.address as any).countryCode || 'PL',
        description: userSettings.company.description,
        identifierType: 'nip',
        fieldsToShow: CompanyFieldsUtils.normalize(this.defaultVisibleSellerFields)
      })

      // Dla "wystaw podobny" zachowaj konto bankowe skopiowane z oryginału (nie nadpisuj domyślnym)
      const defaultBankAccount = this.bankAccounts.find(x => x.isDefault == true)
      if (defaultBankAccount && !this.similarDocumentId) {
        // Używamy setBankAccountFull żeby przekazać pełne dane konta wraz z polami KSeF
        this.invoice.setBankAccountFull({
          accountNumber: defaultBankAccount.accountNumber,
          swift: (defaultBankAccount as any).swift,
          bank: defaultBankAccount.bank,
          accountDescription: (defaultBankAccount as any).accountDescription,
          bankOwnAccountType: (defaultBankAccount as any).bankOwnAccountType
        })
      }

      // Set symbol from documents
      this._setSymbol()

      if (userSettings.settings.autocomplete.documentNumbering) {
        this.setNextDocumentName();
      }

      if (Utils.isDefined(userSettings, "address.city")) {
        this.invoice.setPlaceHeaderValue(userSettings.address.city)
      }

      if (!Utils.isNullOrEmpty(userSettings.settings.autocomplete.issuePlace)) {
        this.invoice.setPlaceHeaderValue(userSettings.settings.autocomplete.issuePlace)
      }

      if (!Utils.isNullOrEmpty(userSettings.settings.autocomplete.signatures) && userSettings.settings.autocomplete.signatures == true) {
        this.invoice.setIssuerSignatureShow(true)
        this.invoice.setIssuerSignatureValue(`${userSettings.user.firstName} ${userSettings.user.lastName}`)
        this.invoice.setReceiverSignatureShow(true)
        this.invoice.setReceiverSignatureValue('')
      }

      if (Utils.isDefined(userSettings, "settings.autocomplete.comments") && userSettings.settings.autocomplete.comments?.length > 0) {
        this.invoice.set('comments', userSettings.settings.autocomplete.comments)
        this.invoice.hasComments = true
        this.generalFieldsToShow.add('hasComments')
      }

      // Auto-enable GTU if user has enableGTU setting
      if (Utils.isDefined(userSettings, "settings.autocomplete.enableGTU") && userSettings.settings.autocomplete.enableGTU === true) {
        this.invoice.hasGTU = true
        this.generalFieldsToShow.add('hasGTU')
      }

      // Auto-enable PKWiU if user has enablePKWiU setting
      if (Utils.isDefined(userSettings, "settings.autocomplete.enablePKWiU") && userSettings.settings.autocomplete.enablePKWiU === true) {
        this.invoice.hasPKWiU = true
        this.generalFieldsToShow.add('hasPKWiU')
      }

      // Włącz opcję JST jeśli użytkownik ma włączone w ustawieniach
      if (Utils.isDefined(userSettings, "settings.general.enableJst") && userSettings.settings.general?.enableJst === true) {
        this.enableJst = true;
      }

      // Set showPKWiU from user settings
      if (Utils.isDefined(userSettings, "settings.autocomplete.showPKWiU")) {
        this.invoice.showPKWiU = userSettings.settings.autocomplete.showPKWiU !== undefined ? userSettings.settings.autocomplete.showPKWiU : true;
        // Dodaj showPKWiU do generalFieldsToShow jeśli jest włączone
        if (this.invoice.showPKWiU) {
          this.generalFieldsToShow.add('showPKWiU')
        }
      } else {
        // Jeśli nie ma ustawienia, użyj domyślnej wartości true
        this.invoice.showPKWiU = true;
        this.generalFieldsToShow.add('showPKWiU')
      }

      // Set showKsefQrCode from user settings
      if (Utils.isDefined(userSettings, "settings.autocomplete.showKsefQrCode")) {
        this.invoice['showKsefQrCode'] = (userSettings.settings.autocomplete as any).showKsefQrCode !== undefined ? (userSettings.settings.autocomplete as any).showKsefQrCode : true;
        // Dodaj showKsefQrCode do generalFieldsToShow jeśli jest włączone
        if (this.invoice['showKsefQrCode']) {
          this.generalFieldsToShow.add('showKsefQrCode')
        }
      } else {
        // Jeśli nie ma ustawienia, użyj domyślnej wartości true
        this.invoice['showKsefQrCode'] = true;
        this.generalFieldsToShow.add('showKsefQrCode')
      }

      // Set showConvertedAmount from user settings
      if (Utils.isDefined(userSettings, "settings.autocomplete.showConvertedAmount")) {
        this.invoice.showConvertedAmount = (userSettings.settings.autocomplete as any).showConvertedAmount ?? false;
        if (this.invoice.showConvertedAmount) {
          this.generalFieldsToShow.add('showConvertedAmount')
        }
      }

      // Podstawa zwolnienia z VAT jest aplikowana automatycznie przez annotations-card
      // gdy użytkownik wybierze stawkę "zw" na pozycji (patrz: applyDefaultVatExemptionIfNeeded)

      // Tryb wprowadzania cen (netto/brutto)
      if (Utils.isDefined(userSettings, "settings.autocomplete.priceInputMode")) {
        this.priceInputMode = userSettings.settings.autocomplete.priceInputMode || PriceInputMode.NETTO;
      }

      // Automatyczne adnotacje dla nowych dokumentów (tylko świeży dokument,
      // nie korekta i nie "wystaw podobny", które mają własne źródło adnotacji)
      if (!this.toCorrectInvoiceId && !this.similarDocumentId) {
        this.applyDefaultAnnotations(userSettings);
      }

    }

    this.syncVatExemptionSource();

    // Status płatności: dla "wystaw podobny" skopiuj z oryginału, w innym wypadku użyj domyślnego z ustawień
    // - status 0 ("Zapłacono"): ukryj "Termin płatności", pokaż "Data otrzymania zapłaty"
    const defaultPaymentStatus = ObjectUtils.getNestedValue(userSettings, 'settings.autocomplete.defaultPaymentStatus');
    const fallbackPaymentStatus: 0 | 1 = defaultPaymentStatus === 1 ? 1 : 0;
    this.onPaymentStatusChange(this._similarPaymentStatus != null ? this._similarPaymentStatus : fallbackPaymentStatus);

  }

  // Observe invoice change
  private _isRecalculatingSettlement = false;
  private _settlementInitialLoadDone = false;
  private _isRecalculatingCorrectionAdvance = false;
  private _isRecalculatingCorrectionSettlement = false;
  observer = (data: any) => {
    if (this._isRecalculatingSettlement) return;
    if (this._isRecalculatingCorrectionAdvance) return;
    if (this._isRecalculatingCorrectionSettlement) return;
    this.renderPreview()
  };

  addedObserver = false

  addInvoiceObserver() {
    if (this.addedObserver) return;
    if (Utils.isNullOrEmpty(this.invoice)) return;
    if (typeof this.invoice.addObserver == 'undefined') { console.warn("[OBSERVER] - Can't register invoice observer.", this.invoice); return; }
    this.addedObserver = true;
    this.invoice.addObserver(this.observer);
  }

  removeInvoiceObserver() {
    this.addedObserver = false
    if (!this.addedObserver) return;
    if (Utils.isNullOrEmpty(this.invoice)) return;
    if (typeof this.invoice.removeObservers == 'undefined') return;
    this.invoice.removeObservers()
  }

  public updateDocumentNo(documentNo: number) {
    this.invoice.setDocumentNo(documentNo)
    this.checkDocumentNumberUniqueness()
    this.renderPreview()
  }

  /**
   * Aktualizuje symbol dokumentu i sprawdza unikalność numeru
   */
  public updateSymbol(symbol: string) {
    this.invoice.setSymbol(symbol)
    this.checkDocumentNumberUniqueness()
    this.renderPreview()
  }

  /**
   * Sprawdza czy numer dokumentu jest unikalny w obrębie tego samego typu dokumentu.
   * Każdy typ dokumentu (FakturaVAT, FakturaZaliczka, FakturaKorygujaca, FakturaKoncowa) 
   * ma własną numerację.
   * Sprawdzamy po: documentNo + formattedDateNumber + documentType (bez symbolu).
   * Przy edycji pomija aktualnie edytowany dokument.
   */
  public checkDocumentNumberUniqueness() {
    // Pobierz kluczowe pola do porównania
    const currentDocumentNo = this.invoice.documentNo
    const currentFormattedDateNumber = this.invoice.formattedDateNumber
    const currentDocumentType = this.invoice.documentType
    const currentNumberingFormat = this.invoice.numberingFormat
    
    if (Utils.isNullOrEmpty(currentDocumentNo)) {
      this.isInvoiceNameAvailable = true
      this.duplicateDocumentId = null
      return
    }
    
    // Pobierz wszystkie lokalne dokumenty (bez usuniętych)
    const allDocuments = this._documentsService.getAllDocumentsSync()
    
    // Szukaj duplikatu - ten sam numer, data i typ dokumentu (symbol nie ma znaczenia)
    const duplicate = allDocuments.find(doc => {
      // Pomiń aktualnie edytowany dokument
      if (this.invoice._id && doc._id === this.invoice._id) {
        return false
      }
      
      // Musi być ten sam typ dokumentu (lub wspólna numeracja FakturaKorygujaca <-> FakturaKorygujacaZaliczkowa)
      const sharedNumberingTypes = ['FakturaKorygujaca', 'FakturaKorygujacaZaliczkowa'];
      if (sharedNumberingTypes.includes(currentDocumentType)) {
        if (!sharedNumberingTypes.includes(doc.documentType)) {
          return false
        }
      } else if (doc.documentType !== currentDocumentType) {
        return false
      }
      
      // Musi być ten sam numer
      if (doc.documentNo != currentDocumentNo) {
        return false
      }
      
      // Oblicz formattedDateNumber dla dokumentu z bazy (jeśli nie ma, oblicz z issueDate)
      let docFormattedDateNumber: string | null = null
      if (doc.numberingFormat && doc.issueDate) {
        const date = DateTime.fromISO(doc.issueDate)
        if (date.isValid) {
          docFormattedDateNumber = doc.numberingFormat
            .replace('MM', date.month.toString().padStart(2, '0'))
            .replace('YYYY', date.year.toString())
        }
      }
      
      // Porównaj formattedDateNumber
      return docFormattedDateNumber === currentFormattedDateNumber
    })
    
    if (duplicate) {
      this.isInvoiceNameAvailable = false
      this.duplicateDocumentId = duplicate._id
    } else {
      this.isInvoiceNameAvailable = true
      this.duplicateDocumentId = null
    }
  }

  onOptionSelected(event: any, product) {
    const selectedProduct = event.option.value;  // This contains the full product object

    // Faktura WDT - default tax rate is 0%
    if (this.invoice.documentType == 'FakturaWDT') selectedProduct.vatRate = 0
    product.update(selectedProduct);
    this.foundProducts = []
  }

  displayProductNameFn(product: Product): string {
    return product && product.name ? product.name : '';
  }

  resetExchangeRate() {
    this.latestExchangeData = null
    this.invoice.setExchangeRate(null)
  }



  /**
 * Checks exchange rate of currency other than 'PLN'
 */
  public checkExchangeRate() {
    if (!this.invoice) return
    if (!this.invoice.issueDateHeader.value) return

    // Get date
    let date = DateTime.fromISO(this.invoice.issueDateHeader.value).minus({ days: 1 })
    // Jeśli dzień przypada na weekend, przesuwamy na ostatni piątek
    if (date.weekday === 6) { // Sobota
      date = date.minus({ days: 1 }); // Piątek
    } else if (date.weekday === 7) { // Niedziela
      date = date.minus({ days: 2 }); // Piątek
    }

    if (date.diffNow('seconds').as('seconds') > 0) {
      this.latestExchangeData = null
      this.invoice.setExchangeRate(null)
      return
    }


    const formattedDate = date.toISODate(); // Sformatuj do ISO (YYYY-MM-DD)

    // Check currency if exchange rate is available in NBP
    const currency = this.invoice.currency
    const currencyData = AppData.Currencies.find(x => x.id == currency)
    if (!currencyData) return
    if (currencyData.availableExchangeRate == false) return

    this._nbpApiService.getExchangeRate(formattedDate, currency)
      .pipe(take(1))
      .subscribe({
        next: (response: APIResponse) => {

          if (response.success != true) {
            this._snackbarService.showSnackBar(`Nie udało się automatycznie pobrać kursu ${currency}/PLN z dnia ${date}.`, 'error')
            return
          }
          this.latestExchangeData = response.data
          this.invoice.setExchangeRate(response.data.rate)
        }
      })
  }

  latestExchangeData:any = null
  resetLatestExchangeDate() {
    this.latestExchangeData = null
  }

  /**
   * Obsługuje zmianę statusu płatności.
   * Przy "Zapłacono" automatycznie:
   * - ukrywa termin płatności
   * - włącza "Data otrzymania zapłaty"
   */
  toggleShowPaymentSection() {
    this.invoice.showPaymentSection = !this.invoice.showPaymentSection;
    this.renderPreview();
  }

  onPaymentStatusChange(status: 0 | 1) {
    this.invoice.setPaymentStatus(status);

    // Zapłacono
    if (status === 0) {
      // Ukryj termin płatności
      this.invoice.setPaymentDeadlineShow(false);

      // Włącz "Data otrzymania zapłaty" (PaymentDateHeaders id: 2)
      this.invoice.setAdditionalPaymentDateShow(true);
      this.invoice.setAdditionalPaymentDateHeader(AppData.PaymentDateHeaders[2].name);
      this.generalFieldsToShow.add('hasAdditionalPaymentDate');
    }
    // Do zapłaty
    else if (status === 1) {
      // Pokaż termin płatności
      this.invoice.setPaymentDeadlineShow(true);

      // Ukryj dodatkową datę płatności
      this.invoice.setAdditionalPaymentDateShow(false);
      this.generalFieldsToShow.delete('hasAdditionalPaymentDate');
    }

    this.renderPreview();
  }

  /**
   * Obsługa zmiany sposobu płatności.
   * Jeśli wybrano przelew (ksefValue === 6, ale nie "zapłacono ..."), termin płatności jest w przyszłości,
   * a status płatności to "Zapłacono", zaproponuj zmianę statusu na "Do zapłaty".
   */
  onPaymentMethodChange(index: number) {
    this.invoice.setPaymentMethod(index);
    this._maybeSuggestUnpaidStatus();
    this.renderPreview();
  }

  /**
   * Obsługa zmiany terminu płatności (widoczne gdy status = Do zapłaty).
   */
  onPaymentDeadlineChange(value: string) {
    this.invoice.setPaymentDeadlineValue(value);
    this._maybeSuggestUnpaidStatus();
    this.renderPreview();
  }

  /**
   * Obsługa zmiany "Daty otrzymania zapłaty" (widoczne gdy status = Zapłacono).
   * Jeśli data jest w przyszłości i wybrano przelew, sugerujemy zmianę statusu na "Do zapłaty".
   */
  onAdditionalPaymentDateChange(value: string) {
    this.invoice.setAdditionalPaymentDateValue(value);
    this._maybeSuggestUnpaidStatus();
    this.renderPreview();
  }

  private _maybeSuggestUnpaidStatus() {
    const method = AppData.PaymentMethods[this.invoice.paymentMethod.value];
    if (!method) return;

    // Tylko metody typu "przelew" które nie oznaczają już zrealizowanej płatności
    const isTransfer = method.ksefValue === 6 && !method.name.toLowerCase().startsWith('zapłacono');
    if (!isTransfer) return;

    // Sugestię pokazujemy tylko gdy status to obecnie "Zapłacono"
    if (this.invoice.paymentStatus.value !== 0) return;

    // Gdy status = "Zapłacono", widoczne jest pole "Data otrzymania zapłaty",
    // a "Termin płatności" jest ukryty. Bierzemy datę widocznego pola.
    const dateValue = this.invoice.additionalPaymentDateHeader?.value
                      || this.invoice.paymentDeadline?.value;
    if (!dateValue) return;

    const date = DateTime.fromISO(dateValue).startOf('day');
    const today = DateTime.now().startOf('day');
    if (!date.isValid || date <= today) return;

    this._dialogService.confirmDialog({
      title: 'Zmiana statusu płatności',
      message: `Wybrano płatność „${method.name}" z datą w przyszłości (${date.toFormat('dd.MM.yyyy')}). Czy zmienić status płatności na „Do zapłaty"?`,
      type: 'info',
      showIcon: true,
      confirmText: 'Tak, zmień',
      cancelText: 'Nie'
    }).subscribe({
      next: (confirmed) => {
        if (confirmed === true) {
          // Przenieś bieżącą datę z "Data otrzymania zapłaty" do "Termin płatności"
          this.invoice.setPaymentDeadlineValue(dateValue);
          this.onPaymentStatusChange(1);
        }
      }
    });
  }

  // On updates in forms
  updateSeller(client: Company | DbClient) {
    const company = client instanceof Company ? client : new Company(client);
    this.invoice.setSeller(company);
    // Refresh signatures on updates
    this.invoice.toggleSignatures(this.generalFieldsToShow.has('signatures'))
    this.renderPreview()
  }

  updateBuyer(client: DbClient) {
    const company = new Company(client);

    // Auto-popraw zduplikowany kod kraju w VAT UE (np. DE + DE124124124 → DE124124124)
    if (company.vatUE && company.countryCode && company.countryCode !== 'PL') {
      const prefix = company.countryCode.toUpperCase();
      const upper = company.vatUE.toUpperCase();
      if (upper.startsWith(prefix) && /^[A-Z]{2}/.test(upper)) {
        company.vatUE = company.vatUE.substring(prefix.length);
      }
    }

    this.invoice.setBuyer(company);
    // Refresh signatures on updates
    this.invoice.toggleSignatures(this.generalFieldsToShow.has('signatures'))
    if (this.invoice._id != null) this.updateDocument(false)
    this.renderPreview()
  }

  updateReceiver(client: DbClient) {
    this.invoice.setReceiver(new Company(client));
    if (this.invoice._id != null) this.updateDocument(false)
    this.renderPreview()
  }

  /**
   * Sprawdza czy kontrahent ma niekompletne dane adresowe
   */
  isAddressIncomplete(client: any): boolean {
    return KsefClientValidatorUtils.isAddressIncomplete(client);
  }

  /**
   * Obsługa włączenia/wyłączenia trybu samofakturowania
   * W samofakturowaniu:
   * - Sprzedawca = kontrahent (do wyboru)
   * - Nabywca = użytkownik (dane z konta)
   * - Dokument oznaczony jako koszt (direction: 'expense')
   */
  /**
   * Obsługa zmiany "Faktura do paragonu" (FP, art. 109 ust. 3d) - sekcja Informacje dodatkowe.
   * To NIE adnotacja - osobne pole additionalInfo (sekcja KSeF "Informacje dodatkowe").
   */
  onInvoiceToReceiptChange(enabled: boolean) {
    this.invoice.additionalInfo.isInvoiceToReceipt = enabled;
    this.renderPreview();
  }

  onSelfInvoicingChange(enabled: boolean) {
    this.isSelfInvoicingMode = enabled;
    
    if (enabled) {
      // Włączamy samofakturowanie
      // 1. Zapisz dane użytkownika (obecnie jako seller) do wykorzystania jako buyer
      this._originalSellerData = new Company(this.invoice.seller);
      
      // 2. Obecny buyer (kontrahent) staje się sellerem
      const currentBuyer = new Company(this.invoice.buyer);
      this.invoice.setSeller(currentBuyer);
      
      // 3. Użytkownik (poprzedni seller) staje się buyerem  
      this.invoice.setBuyer(this._originalSellerData);
      
      // 4. Oznacz dokument jako koszt (expense)
      this.invoice.setDirection('expense');
      
    } else {
      // Wyłączamy samofakturowanie
      if (this._originalSellerData) {
        // 1. Obecny seller (kontrahent) wraca jako buyer
        const currentSeller = new Company(this.invoice.seller);
        this.invoice.setBuyer(currentSeller);
        
        // 2. Przywróć oryginalne dane użytkownika jako seller
        this.invoice.setSeller(this._originalSellerData);
        
        // 3. Przywróć direction na income
        this.invoice.setDirection('income');
        
        this._originalSellerData = null;
      }
    }
    
    // Odśwież podgląd
    this.invoice.toggleSignatures(this.generalFieldsToShow.has('signatures'));
    this.renderPreview();
  }

  /**
   * Obsługa zmiany adnotacji MPP (mechanizm podzielonej płatności)
   * Automatycznie wybiera konto VAT jeśli użytkownik ma takie zdefiniowane
   */
  onSplitPaymentChange(enabled: boolean) {
    if (enabled) {
      // Szukaj konta z flagą isVATAccount
      const vatAccount = this.bankAccounts.find(acc => acc.isVATAccount === true);
      if (vatAccount) {
        // Ustaw konto VAT (osobne pole na fakturze) z pełnymi danymi
        this.invoice.setVatAccountNumber(
          vatAccount.accountNumber,
          vatAccount.bank,
          vatAccount.swift,
          vatAccount.accountDescription
        );
        this.renderPreview();
      }
    }
    // Gdy MPP jest wyłączone, nie zmieniamy konta - użytkownik może chcieć zachować obecne
  }

  /**
   * Obsługuje zmianę wybranego konta VAT - przekazuje pełne dane konta wraz z nazwą banku, SWIFT i opisem
   * @param accountNumber Numer wybranego konta VAT
   */
  onVatAccountChange(accountNumber: string) {
    const selectedAccount = this.bankAccounts.find(x => x.accountNumber === accountNumber);
    if (selectedAccount) {
      this.invoice.setVatAccountNumber(
        selectedAccount.accountNumber,
        selectedAccount.bank,
        selectedAccount.swift,
        selectedAccount.accountDescription
      );
    } else {
      // Jeśli nie znaleziono konta (np. ręcznie wpisany numer)
      this.invoice.setVatAccountNumber(accountNumber);
    }
  }

  checkBankAccounts() {
    if (typeof this.invoice == 'undefined') return;
    if (Utils.isNullOrEmpty(this.invoice.bankAccountNumber.value)) return;
    if (!this.bankAccounts.find(x => x.accountNumber == this.invoice.bankAccountNumber.value)) {
      const newBankAccount = { bank: 'Konto bankowe', accountNumber: this.invoice.bankAccountNumber.value }
      this.bankAccounts.push(newBankAccount)
    }
  }

  /**
   * Obsługuje zmianę wybranego konta bankowego - przekazuje pełne dane konta wraz z polami KSeF
   * @param accountNumber Numer wybranego konta
   */
  onBankAccountChange(accountNumber: string) {
    const selectedAccount = this.bankAccounts.find(x => x.accountNumber === accountNumber);
    if (selectedAccount) {
      this.invoice.setBankAccountFull({
        accountNumber: selectedAccount.accountNumber,
        swift: (selectedAccount as any).swift,
        bank: selectedAccount.bank,
        accountDescription: (selectedAccount as any).accountDescription,
        bankOwnAccountType: (selectedAccount as any).bankOwnAccountType
      });
    } else {
      // Jeśli nie znaleziono konta (np. ręcznie wpisany numer)
      this.invoice.setBankAccountNumber(accountNumber);
    }
  }

  /**
   * Zwraca nazwę banku na podstawie numeru konta
   */
  getBankNameByAccountNumber(accountNumber: string): string | null {
    const bankAccount = this.bankAccounts.find(acc => acc.accountNumber === accountNumber);
    return bankAccount?.bank || null;
  }

  /**
   * Zwraca listę kont bankowych dostępnych do dodania jako dodatkowe (bez już wybranych)
   */
  getAvailableBankAccountsForAdditional(currentIndex: number): IBankAccount[] {
    const selectedNumbers = new Set<string>();
    // Dodaj główne konto
    if (this.invoice.bankAccountNumber.value) {
      selectedNumbers.add(this.invoice.bankAccountNumber.value);
    }
    // Dodaj wszystkie dodatkowe konta oprócz bieżącego
    this.invoice.additionalBankAccounts.forEach((acc: any, idx: number) => {
      if (idx !== currentIndex && acc.value) {
        selectedNumbers.add(acc.value);
      }
    });
    
    return this.bankAccounts.filter(acc => !selectedNumbers.has(acc.accountNumber));
  }

  /**
   * Zwraca listę kont bankowych dostępnych do dodania jako nowe dodatkowe
   */
  getAvailableBankAccountsForNew(): IBankAccount[] {
    const selectedNumbers = new Set<string>();
    // Dodaj główne konto
    if (this.invoice.bankAccountNumber.value) {
      selectedNumbers.add(this.invoice.bankAccountNumber.value);
    }
    // Dodaj wszystkie dodatkowe konta
    this.invoice.additionalBankAccounts.forEach((acc: any) => {
      if (acc.value) {
        selectedNumbers.add(acc.value);
      }
    });
    
    return this.bankAccounts.filter(acc => !selectedNumbers.has(acc.accountNumber));
  }

  /**
   * Dodaje nowe dodatkowe konto bankowe
   */
  addAdditionalBankAccount() {
    const availableAccounts = this.getAvailableBankAccountsForNew();
    if (availableAccounts.length > 0) {
      const firstAvailable = availableAccounts[0];
      this.invoice.addAdditionalBankAccount({
        accountNumber: firstAvailable.accountNumber,
        bank: firstAvailable.bank,
        swift: (firstAvailable as any).swift,
        accountDescription: (firstAvailable as any).accountDescription,
        bankOwnAccountType: (firstAvailable as any).bankOwnAccountType
      });
      this.renderPreview();
    }
  }

  /**
   * Obsługuje zmianę dodatkowego konta bankowego
   */
  onAdditionalBankAccountChange(index: number, accountNumber: string | null) {
    if (!accountNumber) {
      // Usuń konto z listy
      this.invoice.removeAdditionalBankAccount(index);
    } else {
      // Zaktualizuj konto
      const selectedAccount = this.bankAccounts.find(x => x.accountNumber === accountNumber);
      if (selectedAccount) {
        // Zaktualizuj element w tablicy
        this.invoice.additionalBankAccounts[index] = {
          value: selectedAccount.accountNumber,
          text: selectedAccount.accountNumber,
          swift: (selectedAccount as any).swift || undefined,
          bank: selectedAccount.bank || undefined,
          accountDescription: (selectedAccount as any).accountDescription || undefined,
          bankOwnAccountType: (selectedAccount as any).bankOwnAccountType || null
        };
        this.invoice.notifyObservers();
      }
    }
    this.renderPreview();
  }

  checkVatRates() {
    if (typeof this.invoice == 'undefined') return;

    // Sprawdza czy stawki VAT z produktów są dostępne w liście
    this.invoice.products.forEach((product: Product) => {
      // Normalizacja legacy stawek VAT z dokumentów (0 → '0 KR', 'np' → 'np I')
      const normalizedRate = VatRateUtils.normalizeLegacyVatRate(product.vatRate);
      if (normalizedRate !== product.vatRate) {
        product.setTax(normalizedRate);
      }
      if (!this.vatRates.find(x => x.value == product.vatRate)) {
        const vatRate = AppData.VatRates.find(x => x.value == product.vatRate)
        if (typeof vatRate != 'undefined') this.vatRates.push(vatRate)
      }
    })

    // Sprawdza czy domyślna stawka jest dostępna
    if (!this.vatRates.find(x => x.value == this.defaultTaxRate)) {
      const vatRate = AppData.VatRates.find(x => x.value == this.defaultTaxRate)
      if (typeof vatRate != 'undefined') this.vatRates.push(vatRate)
    }

    // Sortowanie: stawki specjalne (string) na początku, potem numeryczne rosnąco
    this.vatRates.sort((a, b) => {
      const aIsNum = VatRateUtils.isNumberVatRate(a.value);
      const bIsNum = VatRateUtils.isNumberVatRate(b.value);
      if (aIsNum && bIsNum) return Number(a.value) - Number(b.value);
      if (!aIsNum && !bIsNum) return 0; // Zachowaj kolejność oryginalną dla specjalnych
      return aIsNum ? 1 : -1; // Specjalne przed numerycznymi
    });
  }

  zoom: number | 'auto' = 66
  zoomIn() {
    if (this.zoom == 'auto') this.zoom = 100
    this.zoom += 7
    if (this.zoom > 100) this.zoom = 100
  }

  zoomOut() {
    if (this.zoom == 'auto') this.zoom = 100
    this.zoom -= 7
    if (this.zoom < 30) this.zoom = 30
  }

  public showNumberingFormatDialog() {
    const dialog = this._dialog.open(AutocompleteSettingsDialogComponent, {
      data: {},
      panelClass: 'fakturnia-responsive-dialog',
    })

  }


  public getNextDocumentNo() {
    if (this.invoice == null) return;
    const documentNo = this._documentsService.getNextDocumentNo(this.invoice, this.numberingType)
    return documentNo
  }

  setNextDocumentName() {

    if (!Utils.isNullOrEmpty(this.invoice._id)) return
    if (!Utils.isDefined(this.settings, "autocomplete.documentNumbering") || !this.settings.autocomplete.documentNumbering) {
      this.invoice.setDocumentNo(1)
      this.checkDocumentNumberUniqueness()
      return
    }
    const documentNo: any = this.getNextDocumentNo()
    if (!Number.isNaN(documentNo)) {
      this.invoice.setDocumentNo(documentNo)
    }
   
    this.checkDocumentNumberUniqueness()
    this.renderPreview()
  }

  checkInvoiceName() {
    if (!Utils.isNullOrEmpty(this.invoice._id)) return;
    if (!Utils.isDefined(this.settings, "autocomplete.documentNumbering") || !this.settings.autocomplete.documentNumbering) return;
    
    const nextNumber = this.getNextDocumentNo();
    if (Utils.isNullOrEmpty(nextNumber)) return

    if (nextNumber == this.invoice.documentNo) return 

    this._dialogService.confirmDialog({
      confirmText: "Zmień",
      message: `Zaktualizować numer dokumentu? Sugerowany numer to ${nextNumber}`,
      title: 'Nazwa dokumentu',
      showIcon: true,
      cancelText: "Nie",
      type: "info"
    })
    .subscribe({
      next: (data) => {
        if (data != null && data == true) {
          if (nextNumber) this.invoice.setDocumentNo(nextNumber) 
        }
      }
    })
    
  }

  foundProducts: any = [];
  findProducts(productName) {
    productName = productName.toLowerCase();

    const paginatedResults = this._productsService.browseProducts({
      currentPage: 1,
      pageSize: 20,
      filters: [
        (product: DbProduct) => product.isDeleted == false
      ],
      activeFilters: [
        ['searchText', productName]
      ]
    })

    this.foundProducts = paginatedResults.results
  }

  dismissedSavePrompts = new Set<Product>()

  dismissSaveProduct(product: Product) {
    this.dismissedSavePrompts.add(product)
  }

  saveProduct(product: Product) {

    if (Utils.isDefined(product, "_id")) return

    const productObj = product.toObject()
    productObj.currency = this.invoice.currency

    this._productsApiService.create(productObj)
      .pipe(take(1))
      .subscribe(
        {
          next: (response: APIResponse) => {

            if (response.success == false) {

              this._snackbarService.showSnackBar(
                'Nie udało się zapisać danych produktu.',
                'error',
                4000
              )
              return
            }

            this._dataSynchronizerService.next("products", [response.data], null)
            this._synchronizationService.synchronize()
            product._id = response.data._id

            this._snackbarService.showSnackBar(
              'Dane produktu zostały zapisane.',
              'success',
              4000
            )
          }
        }
      )
  }

  /**
   * Dialog do wyboru zamówienia dla faktury zaliczkowej
   */
  showSelectOrderDialog() {
    const dialog = this._dialogService.showSelectInvoiceDialog({
      filters: [
        // Tylko zamówienia
        (document: DbDocument) => document.documentType === 'Zamowienie',
        // Nie usunięte
        (document: DbDocument) => !document.isDeleted,
        // Z produktami
        (document: DbDocument) => document.products && document.products.length > 0
      ],
      selection: 'single'
    });

    const sub = dialog.subscribe({
      next: (data) => {
        if (data == null || typeof data === 'undefined') return;

        if (Array.isArray(data) && data.length > 0) {
          const orderId = data[0];
          const order = this._documentsService.getById(orderId);
          if (order) {
            this.selectedOrder = order;
            this.advancePaymentAmount = order.grossSum || 0;
            this.calculateAdvanceBreakdown();
            
            // Ustaw nabywcę z zamówienia
            if (order.buyer) {
              this.invoice.setBuyer(cloneDeep(order.buyer));
            }
            
            // Zapisz powiązanie
            this.invoice.linkedOrderId = orderId;

            // Ustaw walutę z zamówienia i zablokuj zmianę
            this._setCurrencyFromOrder(order);
          }
        }

        if (data === false) sub.unsubscribe();
      }
    });
  }

  showSelectPrepaymentDialog() {
    const dialog = this._dialogService.showSelectInvoiceDialog({
      filters: [
        (document: DbDocument) => { return (!document.isDeleted && document.isPaid) },
        (document: DbDocument) => { return (document.documentType == 'FakturaVAT' || document.documentType == 'FakturaZaliczka') }
      ],
      selection: 'multiple'
    })

    const sub = dialog.subscribe({
      next: (data) => {
        if (data == null || typeof data == 'undefined') return

        if (Array.isArray(data)) {
          data.forEach(invoiceId => {
            if (this.invoice.prepayments.findIndex(x => x._id == invoiceId) == -1) {
              const invoice = this._documentsService.getById(invoiceId)
              if (invoice) this.invoice.addPrepayment(cloneDeep(invoice))
            }
          });
        }

        if (data == false) sub.unsubscribe()

      }
    })
  }

  showSelectCorrectedInvoiceDialog() {
    // Pobierz ID lub NIP nabywcy z aktualnej faktury (jeśli jest wybrany)
    const currentBuyerId = this.invoice.buyer?._id || this.invoice.buyer?.['id'];
    const currentBuyerNip = this.invoice.buyer?.nip || this.invoice.buyer?.vatUE;

    // Zbierz ID dokumentów, które już mają korektę (nie usunięte korekty)
    const allDocuments = this._documentsService.getAllDocumentsSync();
    const alreadyCorrectedIds = new Set<string>(
      allDocuments
        .filter(doc => !doc.isDeleted && (doc as any).correctedInvoiceId)
        .map(doc => (doc as any).correctedInvoiceId)
    );
    
    const dialog = this._dialogService.showSelectInvoiceDialog({
      filters: [
        // Tylko wystawione i nie usunięte
        (document: DbDocument) => { return (!document.isDeleted && document.isPaid) },
        // Tylko odpowiednie typy dokumentów
        (document: DbDocument) => {
          // FakturaKorygujacaZaliczkowa - tylko faktury zaliczkowe
          if (this.invoice.documentType === 'FakturaKorygujacaZaliczkowa') {
            return document.documentType === 'FakturaZaliczka';
          }
          // FakturaKorygujacaRozliczeniowa - tylko rozliczeniowe i korekty rozliczeniowych
          if (this.invoice.documentType === 'FakturaKorygujacaRozliczeniowa') {
            return document.documentType === 'FakturaRozliczeniowa' || document.documentType === 'FakturaKorygujacaRozliczeniowa';
          }
          // FakturaKorygujaca - tylko FakturaVAT
          return document.documentType === 'FakturaVAT';
        },
        // Nie pozwalaj wybrać dokumentu, który już ma korektę
        (document: DbDocument) => !alreadyCorrectedIds.has(document._id),
        // Tylko lokalne faktury (nie z KSeF)
        (document: DbDocument) => { return (document.source !== 'ksef') },
        // Filtruj po nabywcy (jeśli jest wybrany)
        (document: DbDocument) => { 
          // Jeśli nie ma wybranego nabywcy, pokaż wszystkie
          if (!currentBuyerId && !currentBuyerNip) return true;
          
          // Sprawdź czy nabywca pasuje po ID
          const docBuyerId = document.buyer?._id || document.buyer?.['id'];
          if (currentBuyerId && docBuyerId && currentBuyerId === docBuyerId) return true;
          
          // Sprawdź czy nabywca pasuje po NIP lub VAT UE
          const docBuyerNip = document.buyer?.nip || document.buyer?.vatUE;
          if (currentBuyerNip && docBuyerNip && currentBuyerNip === docBuyerNip) return true;
          
          return false;
        }
      ],
      selection: 'single'
    })

    const sub = dialog.subscribe({
      next: (data) => {
        if (data == null || typeof data == 'undefined') return

        if (Array.isArray(data)) {
          data.forEach(invoiceId => {
            const correctedDoc = this._documentsService.getById(invoiceId)
            if (!correctedDoc) return;

            this.invoice.addCorrectedInvoice(cloneDeep(correctedDoc))

            // Waluta korekty musi być taka sama jak faktury korygowanej
            this.invoice.currency = correctedDoc.currency || 'PLN'
            this.invoice.exchangeRate = (correctedDoc as any).exchangeRate || null

            if (this.invoice.currency !== 'PLN') {
              this.checkExchangeRate()
            }

            // === KOR_ZAL - inicjalizacja danych korekty zaliczki ===
            if (this.invoice.documentType === 'FakturaKorygujacaZaliczkowa' && correctedDoc.documentType === 'FakturaZaliczka') {
              this._initCorrectionOfAdvancePayment(correctedDoc);
            }

            // === KOR_ROZ - inicjalizacja danych korekty rozliczeniowej ===
            if (this.invoice.documentType === 'FakturaKorygujacaRozliczeniowa') {
              this._initCorrectionOfSettlement(correctedDoc);
            }
          });
        }

        if (data == false) sub.unsubscribe()

      }
    })
  }

  removeProduct(indexToRemove: number) {
    this.invoice.products.splice(indexToRemove, 1)
    this.invoice.count();
  }

  addProduct() {

    let defaultTaxRate = 23

    // Faktura WDT - domyślna stawka produktu to 0%
    if (this.invoice.documentType == 'FakturaWDT') defaultTaxRate = 0
    this.invoice.addProducts(new Product(
      {
        _id: '',
        name: '',
        gtu: '',
        unitOfMeasure: 'szt.',
        quantity: 1,
        discount: 0,
        netPrice: 0,
        vatRate: defaultTaxRate,
        parent: this.invoice
      }
    ))
  }

  createPDF(mode: 'download' | 'render') {
    const subscriptionStage = this.userSettings?.subscription?.stage ?? 0
    return InvoiceGenerator.createPDF(this.document, this.invoice, 0, mode, this.logo, subscriptionStage, settings.ksefQrVerifyUrl)
  }

  prevZoom: any = null
  showingPreview = false
  togglePreview() {

    if (this.showingPreview) this.closePreview()
    else this.showPreview()

  }

  /** Close document preview using escape key */
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (!this.showingPreview) return
    if (event.key === 'Escape') {
      this.closePreview();
    }
  }


  closePreview() {
    this.zoom = this.prevZoom
    this.showingPreview = false
  }

  showPreview() {
    this.showingPreview = true
    this.prevZoom = this.zoom
    this.zoom = 'auto'
  }


  dataUrl: any = null
  previewHeight: any = 'auto'
  async renderPreview(): Promise<any> {
    // Ensure no other PDF creation is in progress
    // if (this.isPdfLoaded === false) {
    //   console.warn('PDF creation is already in progress. Waiting...');
    //   return;
    // }

    // Aplikuj lub wyczyść domyślną podstawę zwolnienia z VAT w zależności od stawki "zw"
    this.applyOrClearVatExemptionDefaults();

    // Dla FakturaRozliczeniowa - przelicz dane rozliczenia przy każdej zmianie
    // Pomijamy pierwsze wywołanie w trybie edycji — szanujemy zapisane settlementAmount
    if (this.isSettlementInvoice && this.selectedAdvanceInvoices.length > 0) {
      if (this._settlementInitialLoadDone) {
        this.recalculateSettlementOnProductChange();
      } else {
        this._settlementInitialLoadDone = true;
      }
    }

    // Dla KOR_ZAL - synchronizuj zamówienie po korekcie z modelu przed renderowaniem
    if (this.isCorrectionOfAdvancePayment && this.correctionOrderBefore && this.invoice.products.length > 0) {
      // Ogranicz kwotę zaliczki do wartości zamówienia po korekcie
      const maxAmount = this.correctionOrderAfterGrossSum;
      if (this.correctionAdvanceAmountAfter > maxAmount) {
        this.correctionAdvanceAmountAfter = maxAmount;
      }

      this._isRecalculatingCorrectionAdvance = true;
      this.invoice.recalculateCorrectionAdvance({
        orderBefore: {
          invoiceName: this.correctionOrderBefore.invoiceName,
          grossSum: this.correctionOrderBefore.grossSum,
          products: this.correctionOrderBefore.products.map(toOrderProduct)
        },
        amountBefore: this.correctionAdvanceAmountBefore,
        productsAfter: this.invoice.products.map(toOrderProduct),
        amountAfter: this.correctionAdvanceAmountAfter
      });
      this._isRecalculatingCorrectionAdvance = false;
      this.correctionAdvanceTaxBreakdown = this.invoice.correctionAdvanceTaxBreakdown || [];
    }

    // Dla KOR_ROZ - synchronizuj kwoty korekty rozliczeniowej przed renderowaniem
    if (this.isCorrectionOfSettlementInvoice && this.invoice.correctedInvoice) {
      this._isRecalculatingCorrectionSettlement = true;
      // Automatycznie aktualizuj kwotę rozliczenia na sumę brutto pozycji po korekcie
      const productsGrossSum = this.invoice.products.reduce((sum, p) => sum + (p.grossValue || 0), 0);
      this.correctionSettlementAmountAfter = Math.round(productsGrossSum * 100) / 100;
      this.invoice.correctionSettlementAmountAfter = this.correctionSettlementAmountAfter;
      this.invoice.count();
      this._isRecalculatingCorrectionSettlement = false;
      this.correctionSettlementAmountBefore = this.invoice.correctionSettlementAmountBefore || 0;
    }

    this.isPdfLoaded = false; // Mark as loading
    const docDefinition = this.createPDF('render');

    // Wrap pdfMake.createPdf in a Promise
    await new Promise<void>((resolve, reject) => {
      PdfMake.createPdf(<any>docDefinition).getBase64((dataUrl) => {
        this.dataUrl = dataUrl;
        resolve(); // Resolve the Promise when PDF creation is complete
      });
    })
      .then(async () => {
        // Wait for the PDF to finish loading
        await this._waitForPdfToLoad();
      })



  }

  /**
   * Przelicza dane rozliczenia gdy zmienią się pozycje faktury
   * (nie wywołuje renderPreview, bo to jest wywoływane z renderPreview)
   */
  private recalculateSettlementOnProductChange(): void {
    // Synchronizuj flagę z modelu
    this.invoice.isSettlementAmountManual = this.isSettlementAmountManual;

    // Guard: count() wywołuje notifyObservers → observer → renderPreview → ta metoda
    this._isRecalculatingSettlement = true;
    this.selectedAdvanceInvoicesSum = this.invoice.recalculateSettlement(this.selectedAdvanceInvoices as any);
    this._isRecalculatingSettlement = false;

    // Synchronizuj lokalne zmienne z modelu
    this.settlementAmount = this.invoice.settlementAmount || 0;
  }

  private _waitForPdfToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      const checkInterval = setInterval(() => {

        if (this.isPdfLoaded) {
          clearInterval(checkInterval); // Stop checking once the PDF is loaded
          resolve();
        }
      }, 100); // Check every 100ms
    });
  }


  getRest(value: number | string) {
    return Utils.getRest(value)
  }

  toDecimal(value: any) {
    return Utils.toDecimal(value);
  }

  setMarginProcedure(e) {
    this.invoice.setMarginProcedure(e)
  }

  setDocumentType(id: string) {
    this.document = TemplateUtils.GetDocumentById(id)
  }

  private _setNumberingFormat() {
    // Get format from settings
    const numberingFormat = ObjectUtils.getNestedValue(this.userSettings, "settings.autocomplete.numberingFormat")
    if (!Utils.isNullOrEmpty(numberingFormat)) {
      this.formatInfo = AppData.DocumentNumberFormats.find(x => x.format == numberingFormat)
      this.invoice.setNumberingFormat(this.formatInfo.format)
    }

  }
  private _setNumberingType() {
    const numberingType = ObjectUtils.getNestedValue(this.userSettings, "settings.autocomplete.numberingType")
    if (!Utils.isNullOrEmpty(numberingType)) {
      this.numberingType = numberingType
    }
  }

  private _setSymbol() {
    const symbols = ObjectUtils.getNestedValue(this.userSettings, "settings.autocomplete.documentSymbols")
    if (Utils.isDefined(symbols, this.invoice.documentType)) {
      this.invoice.setSymbol(symbols[this.invoice.documentType])
    }
  }

  switchDocument(id: string) {

    this.document = TemplateUtils.GetDocumentById(id)
    this.invoice.setDocument(this.document);
    this._setSymbol()
    // Maybe it should have new number
    this.setNextDocumentName()

    // If FakturaWDT - change all products taxRate to 0% (its default rate)
    if (id == 'FakturaWDT') {
      for (let product of this.invoice.products) {
        product.setTax(0)
      }
    }

    // ============================================================
    // Reset wszystkich danych specjalnych przy zmianie typu dokumentu
    // ============================================================

    // Reset korygowanego dokumentu
    this.toCorrectInvoiceId = null;
    this.invoice.correctedInvoiceId = null;
    this.invoice.correctedInvoice = null;
    this.invoice.correctionReason = '';

    // Reset danych KOR_ZAL (korekta zaliczkowej)
    this.correctionOrderBefore = null;
    this.correctionAdvanceAmountBefore = 0;
    this.correctionAdvanceAmountAfter = 0;
    this.correctionAdvanceTaxBreakdown = [];
    this.invoice.correctionOrderBefore = undefined;
    this.invoice.correctionOrderAfter = undefined;
    this.invoice.correctionAdvanceAmountBefore = undefined;
    this.invoice.correctionAdvanceAmountAfter = undefined;
    this.invoice.correctionAdvanceTaxBreakdown = undefined;

    // Reset danych KOR_ROZ (korekta rozliczeniowej)
    this.correctionSettlementAmountBefore = 0;
    this.correctionSettlementAmountAfter = 0;
    this.invoice.correctionSettlementAmountBefore = undefined;
    this.invoice.correctionSettlementAmountAfter = undefined;
    this.invoice.correctionSettlementTaxBreakdown = undefined;

    // Reset danych zaliczki (FakturaZaliczka)
    if (id !== 'FakturaZaliczka') {
      this.selectedOrder = null;
      this.advancePaymentAmount = 0;
      this.advancePaymentTaxBreakdown = [];
      this.invoice.linkedOrderId = null;
      this.invoice.linkedOrder = undefined;
      this.invoice.advancePaymentAmount = undefined;
      this.invoice.advancePaymentTaxBreakdown = undefined;
    }

    // Reset danych rozliczeniowej (FakturaRozliczeniowa)
    if (id !== 'FakturaRozliczeniowa') {
      this.selectedAdvanceInvoices = [];
      this.selectedAdvanceInvoicesSum = 0;
      this.settlementAmount = 0;
      this.isSettlementAmountManual = false;
      this.invoice.linkedAdvanceInvoiceIds = undefined;
      this.invoice.linkedAdvanceInvoices = undefined;
      this.invoice.settlementAmount = undefined;
      this.invoice.settlementTaxBreakdown = undefined;
    }

    // ============================================================
    // Logika specyficzna dla nowego typu dokumentu
    // ============================================================

    // Jeśli FakturaZaliczka - załaduj dostępne zamówienia i ukryj datę sprzedaży
    if (id === 'FakturaZaliczka') {
      this.loadAvailableOrders();
      // Ukryj datę sprzedaży - dla zaliczki nie ma sensu (nie ma dostawy towaru/usługi)
      this.invoice.setSubHeaderShow(false);
    } else {
      // Przywróć widoczność daty sprzedaży dla innych typów dokumentów
      this.invoice.setSubHeaderShow(true);
    }

    // Jeśli FakturaRozliczeniowa - załaduj dostępne faktury zaliczkowe
    if (id === 'FakturaRozliczeniowa') {
      this.loadAvailableAdvanceInvoices();
    }
  }

  /**
   * Ładuje listę zamówień dostępnych do powiązania z fakturą zaliczkową
   */
  loadAvailableOrders(): void {
    // Pobierz wszystkie dokumenty typu Zamowienie z BehaviorSubject
    this._documentsService.currentDocuments.pipe(take(1)).subscribe(docs => {
      const allDocs = Object.values(docs) as DbDocument[];
      this.availableOrders = allDocs.filter(doc => 
        doc.documentType === 'Zamowienie' && 
        doc.products && 
        doc.products.length > 0 &&
        !doc.isDeleted
      );
    });
  }

  /**
   * Wybiera zamówienie dla faktury zaliczkowej
   */
  selectOrderForAdvance(orderId: string): void {
    const order = this.availableOrders.find(o => o._id === orderId);
    this.selectedOrder = order || null;
    
    if (this.selectedOrder) {
      // Ustaw maksymalną możliwą kwotę zaliczki jako domyślną
      this.advancePaymentAmount = this.selectedOrder.grossSum || 0;
      this.calculateAdvanceBreakdown();

      // Ustaw walutę z zamówienia i zablokuj zmianę
      this._setCurrencyFromOrder(this.selectedOrder);
    } else {
      this.advancePaymentAmount = 0;
      this.advancePaymentTaxBreakdown = [];
      // Wyczyść linkedOrder na invoice
      this.invoice.linkedOrderId = null;
      this.invoice.linkedOrder = undefined;
      this.invoice.advancePaymentAmount = undefined;
      this.invoice.advancePaymentTaxBreakdown = undefined;
    }
  }

  /**
   * Usuwa wybrane zamówienie z faktury zaliczkowej
   */
  removeSelectedOrder(): void {
    this.selectedOrder = null;
    this.advancePaymentAmount = 0;
    this.advancePaymentTaxBreakdown = [];
    // Wyczyść linkedOrder na invoice
    this.invoice.linkedOrderId = null;
    this.invoice.advancePaymentAmount = undefined;
    this.invoice.advancePaymentTaxBreakdown = undefined;

    // Odblokuj walutę - resetuj do PLN
    this.invoice.currency = 'PLN';
    this.resetExchangeRate();
  }

  /**
   * Ustawia walutę faktury zaliczkowej na podstawie zamówienia.
   * Jeśli zamówienie jest w walucie obcej, automatycznie pobiera kurs NBP.
   */
  private _setCurrencyFromOrder(order: DbDocument): void {
    const orderCurrency = order.currency || 'PLN';
    this.invoice.currency = orderCurrency;

    if (orderCurrency !== 'PLN') {
      // Pobierz kurs waluty z NBP
      this.checkExchangeRate();
    } else {
      // Resetuj kurs dla PLN
      this.resetExchangeRate();
    }
  }

  /**
   * Oblicza proporcjonalny rozkład zaliczki na stawki VAT
   * Używa funkcji calculateAdvancePaymentTaxBreakdown z fakturnia-shared
   */
  calculateAdvanceBreakdown(): void {
    if (!this.selectedOrder || !this.advancePaymentAmount || this.advancePaymentAmount <= 0) {
      this.advancePaymentTaxBreakdown = [];
      // Wyczyść linkedOrder na invoice
      this.invoice.linkedOrderId = null;
      this.invoice.linkedOrder = undefined;
      this.invoice.advancePaymentAmount = undefined;
      this.invoice.advancePaymentTaxBreakdown = undefined;
      return;
    }

    const products = this.selectedOrder.products || [];
    if (products.length === 0) {
      this.advancePaymentTaxBreakdown = [];
      return;
    }

    // Użyj funkcji z fakturnia-shared
    const orderProducts = products.map(p => ({
      name: p.name || '',
      unitOfMeasure: p.unitOfMeasure || 'szt.',
      quantity: p.quantity || 1,
      netPrice: p.netPrice || 0,
      netValue: p.netValue || 0,
      vatRate: p.vatRate ?? 23,
      amountOfVat: p.amountOfVat || 0,
      grossValue: p.grossValue || 0
    }));

    // Oblicz rozkład VAT
    this.advancePaymentTaxBreakdown = calculateAdvancePaymentTaxBreakdown(
      orderProducts,
      this.advancePaymentAmount
    );

    // Ustaw linkedOrder na invoice (dla PDF i zapisu)
    this.invoice.linkedOrderId = this.selectedOrder._id;
    this.invoice.advancePaymentAmount = this.advancePaymentAmount;
    this.invoice.advancePaymentTaxBreakdown = this.advancePaymentTaxBreakdown;
    this.invoice.linkedOrder = {
      invoiceName: this.selectedOrder.invoiceName || this.selectedOrder.documentNumber || 'Zamówienie',
      grossSum: this.selectedOrder.grossSum || 0,
      products: orderProducts
    };

    // Przelicz sumy (toPay, paid, sum) z nową kwotą zaliczki
    this.invoice.count();

    // Odśwież podgląd
    this.renderPreview();
  }

  /**
   * Inicjalizuje fakturę zaliczkową na podstawie zamówienia z query param
   * Ustawia typ dokumentu, nabywcę i wybiera zamówienie
   */
  private _initAdvanceInvoiceFromOrder(orderId: string): void {
    // Zmień typ dokumentu na FakturaZaliczka (używamy switchDocument zamiast setDocumentType)
    this.switchDocument('FakturaZaliczka');
    
    // Znajdź zamówienie synchronicznie
    const orderFromService = this._documentsService.getById(orderId);
    if (orderFromService && orderFromService.documentType === 'Zamowienie') {
      // Dodaj do dostępnych zamówień jeśli nie ma
      if (!this.availableOrders.find(o => o._id === orderId)) {
        this.availableOrders.push(orderFromService);
      }
      this._setupAdvanceFromOrder(orderFromService);
    } else {
      this._snackbarService.showSnackBar('Nie znaleziono zamówienia o wskazanym identyfikatorze.', 'error');
    }
  }

  /**
   * Konfiguruje fakturę zaliczkową na podstawie zamówienia
   */
  private _setupAdvanceFromOrder(order: DbDocument): void {
    // Ustaw nabywcę z zamówienia
    if (order.buyer) {
      this.invoice.setBuyer(order.buyer);
    }
    
    // Ustaw odbiorcę jeśli jest
    if (order.hasReceiver && order.receiver) {
      this.invoice.setReceiver(order.receiver);
      this.generalFieldsToShow.add('hasReceiver');
    }
    
    // Wybierz zamówienie
    this.selectOrderForAdvance(order._id);
  }

  /**
   * Inicjalizuje fakturę rozliczeniową na podstawie faktury zaliczkowej z query param.
   * Zmienia typ na FakturaRozliczeniowa, ustawia nabywcę i wybiera fakturę zaliczkową.
   */
  private _initSettlementInvoiceFromAdvance(advanceInvoiceId: string): void {
    // Zmień typ dokumentu na FakturaRozliczeniowa
    this.switchDocument('FakturaRozliczeniowa');

    // Znajdź fakturę zaliczkową synchronicznie
    const advanceInvoice = this._documentsService.getById(advanceInvoiceId);
    if (!advanceInvoice || advanceInvoice.documentType !== 'FakturaZaliczka') {
      this._snackbarService.showSnackBar('Nie znaleziono faktury zaliczkowej o wskazanym identyfikatorze.', 'error');
      return;
    }

    // Sprawdź czy faktura zaliczkowa nie jest już powiązana z inną fakturą rozliczeniową
    if ((advanceInvoice as any).linkedSettlementInvoiceId) {
      const linkedSettlement = this._documentsService.getById((advanceInvoice as any).linkedSettlementInvoiceId);
      // Pozwól jeśli powiązana faktura rozliczeniowa została usunięta
      if (linkedSettlement && !linkedSettlement.isDeleted) {
        this._snackbarService.showSnackBar('Ta faktura zaliczkowa jest już powiązana z fakturą rozliczeniową.', 'warning');
        return;
      }
    }

    // Ustaw nabywcę z faktury zaliczkowej
    if (advanceInvoice.buyer) {
      this.invoice.setBuyer(advanceInvoice.buyer);
    }

    // Ustaw odbiorcę jeśli jest
    if (advanceInvoice.hasReceiver && advanceInvoice.receiver) {
      this.invoice.setReceiver(advanceInvoice.receiver);
      this.generalFieldsToShow.add('hasReceiver');
    }

    // Skopiuj produkty z zamówienia powiązanego z fakturą zaliczkową (jeśli istnieje)
    const linkedOrderId = (advanceInvoice as any).linkedOrderId;
    if (linkedOrderId) {
      const linkedOrder = this._documentsService.getById(linkedOrderId);
      if (linkedOrder && linkedOrder.products && linkedOrder.products.length > 0) {
        // Wyczyść istniejące produkty i dodaj z zamówienia
        this.invoice.products = [];
        const productsToAdd = linkedOrder.products.map((p: any) =>
          new Product({
            name: p.name || '',
            unitOfMeasure: p.unitOfMeasure || 'szt.',
            quantity: p.quantity || 1,
            netPrice: p.netPrice || 0,
            netValue: p.netValue,
            amountOfVat: p.amountOfVat,
            grossValue: p.grossValue,
            vatRate: p.vatRate ?? 23,
            discount: p.discount || 0
          })
        );
        this.invoice.addProducts(productsToAdd);
      }
    }

    // Ustaw walutę z faktury zaliczkowej
    const advanceCurrency = advanceInvoice.currency || 'PLN';
    this.invoice.currency = advanceCurrency;
    if (advanceCurrency !== 'PLN') {
      this.checkExchangeRate();
    }

    // Wybierz tę fakturę zaliczkową jako powiązaną
    this.selectedAdvanceInvoices = [advanceInvoice];

    // Zbierz inne faktury zaliczkowe tego samego nabywcy i zamówienia (automatycznie)
    const allDocs = this._documentsService.getAllDocumentsSync();
    const buyerNip = advanceInvoice.buyer?.nip;
    const relatedAdvances = allDocs.filter(d =>
      (d.documentType === 'FakturaZaliczka' || d.documentType === 'FakturaKorygujacaZaliczkowa') &&
      !d.isDeleted &&
      d._id !== advanceInvoiceId &&
      (!buyerNip || d.buyer?.nip === buyerNip) &&
      (!(d as any).linkedSettlementInvoiceId || (() => { const s = this._documentsService.getById((d as any).linkedSettlementInvoiceId); return !s || s.isDeleted; })()) &&
      // Powiązane z tym samym zamówieniem (jeśli jest)
      (!linkedOrderId || (d as any).linkedOrderId === linkedOrderId)
    );

    // Dodaj powiązane zaliczki (to samo zamówienie)
    if (relatedAdvances.length > 0) {
      this.selectedAdvanceInvoices = [...this.selectedAdvanceInvoices, ...relatedAdvances];
    }

    // Oblicz dane rozliczenia
    this.calculateSettlementData();
  }

  /**
   * Sprawdza czy typ dokumentu to FakturaZaliczka
   */
  get isAdvancePaymentInvoice(): boolean {
    return this.invoice?.documentType === 'FakturaZaliczka';
  }

  /**
   * Pobiera etykietę stawki VAT do wyświetlenia.
   * Używa VatRateUtils.getDisplayValue() dla spójności z KSeF.
   */
  getVatRateLabel(vatRate: string | number): string {
    return VatRateUtils.getDisplayValue(vatRate);
  }

  /**
   * Pogrupowane podsumowanie stawek VAT dla KOR_ROZ.
   * Grupuje 23%/22%, 8%/7%, 4%/3% itd. wg sufiksów KSeF.
   */
  get groupedCorrectionSettlementBreakdown(): GroupedTaxSum[] {
    if (!this.invoice?.correctionSettlementTaxBreakdown?.length) return [];
    return VatRateUtils.groupTaxBreakdown(this.invoice.correctionSettlementTaxBreakdown);
  }

  /**
   * Suma netto wszystkich pozycji rozkładu zaliczki
   */
  get advanceNetTotal(): number {
    return this.advancePaymentTaxBreakdown.reduce((sum, row) => sum + row.netValue, 0);
  }

  /**
   * Suma VAT wszystkich pozycji rozkładu zaliczki
   */
  get advanceVatTotal(): number {
    return this.advancePaymentTaxBreakdown.reduce((sum, row) => sum + row.vatValue, 0);
  }

  // ============================================================
  // === KOR_ZAL - Korekta faktury zaliczkowej ==================
  // ============================================================

  /**
   * Inicjalizuje dane korekty faktury zaliczkowej na podstawie korygowanej FakturaZaliczka
   */
  private _initCorrectionOfAdvancePayment(correctedInvoice: DbDocument): void {
    // documentType jest już ustawiony na 'FakturaKorygujacaZaliczkowa' przez wywołujący kod
    // getter isCorrectionOfAdvancePayment automatycznie zwróci true

    // Dane "przed korektą" z oryginalnej faktury zaliczkowej
    const originalOrder = (correctedInvoice as any).linkedOrder;
    if (originalOrder) {
      this.correctionOrderBefore = {
        invoiceName: originalOrder.invoiceName || '',
        grossSum: originalOrder.grossSum || 0,
        products: (originalOrder.products || []).map((p: any) => ({
          name: p.name || '',
          unitOfMeasure: p.unitOfMeasure || 'szt.',
          quantity: p.quantity || 1,
          netPrice: p.netPrice || 0,
          netValue: p.netValue || 0,
          vatRate: p.vatRate ?? 23,
          amountOfVat: p.amountOfVat || 0,
          grossValue: p.grossValue || 0
        }))
      };
    }

    this.correctionAdvanceAmountBefore = (correctedInvoice as any).advancePaymentAmount || correctedInvoice.grossSum || 0;

    // Inicjalizuj "po korekcie" jako kopię "przed korektą"
    this.correctionAdvanceAmountAfter = this.correctionAdvanceAmountBefore;

    if (this.correctionOrderBefore) {
      // Wyczyść istniejące produkty i dodaj kopię z zamówienia przed korektą
      this.invoice.products = [];
      const productsToAdd = this.correctionOrderBefore.products.map((p: any) =>
        new Product({
          name: p.name || '',
          unitOfMeasure: p.unitOfMeasure || 'szt.',
          quantity: p.quantity || 1,
          netPrice: p.netPrice || 0,
          vatRate: p.vatRate ?? 23,
          discount: 0
        })
      );
      // Dodaj produkty przez addProducts (ustawia parent, więc zmiany wywołują count())
      this.invoice.addProducts(productsToAdd);
    }

    // Oblicz rozkład VAT korekty (na początku = 0, bo before == after)
    this.calculateCorrectionAdvanceBreakdown();
  }

  /**
   * Oblicza wartość brutto zamówienia po korekcie (suma produktów invoice)
   */
  get correctionOrderAfterGrossSum(): number {
    if (!this.isCorrectionOfAdvancePayment) return 0;
    return this.invoice.products.reduce((sum, p) => sum + (p.grossValue || 0), 0);
  }

  /**
   * Oblicza wartość netto zamówienia po korekcie (suma produktów invoice)
   */
  get correctionOrderAfterNetSum(): number {
    if (!this.isCorrectionOfAdvancePayment) return 0;
    return this.invoice.products.reduce((sum, p) => sum + (p.netValue || 0), 0);
  }

  /**
   * Suma netto rozkładu VAT korekty zaliczki
   */
  get correctionAdvanceNetTotal(): number {
    return this.correctionAdvanceTaxBreakdown.reduce((sum, row) => sum + row.netValue, 0);
  }

  /**
   * Suma VAT rozkładu VAT korekty zaliczki
   */
  get correctionAdvanceVatTotal(): number {
    return this.correctionAdvanceTaxBreakdown.reduce((sum, row) => sum + row.vatValue, 0);
  }

  /**
   * Oblicza proporcjonalny rozkład VAT korekty zaliczki (różnica przed/po)
   */
  calculateCorrectionAdvanceBreakdown(): void {
    if (!this.correctionOrderBefore || this.invoice.products.length === 0) {
      this.correctionAdvanceTaxBreakdown = [];
      return;
    }

    // Deleguj do modelu — oblicza rozkład VAT, ustawia correction* na invoice, wywołuje count()
    this.invoice.recalculateCorrectionAdvance({
      orderBefore: {
        invoiceName: this.correctionOrderBefore.invoiceName,
        grossSum: this.correctionOrderBefore.grossSum,
        products: this.correctionOrderBefore.products.map(toOrderProduct)
      },
      amountBefore: this.correctionAdvanceAmountBefore,
      productsAfter: this.invoice.products.map(toOrderProduct),
      amountAfter: this.correctionAdvanceAmountAfter
    });

    // Synchronizuj lokalną zmienną z modelu
    this.correctionAdvanceTaxBreakdown = this.invoice.correctionAdvanceTaxBreakdown || [];

    // Odśwież podgląd
    this.renderPreview();
  }

  /**
   * Obsługuje zmianę produktu w zamówieniu po korekcie - przelicza wszystko
   */
  onCorrectionOrderAfterProductChange(): void {
    // Sprawdź czy kwota zaliczki nie przekracza nowej wartości zamówienia
    const maxAmount = this.correctionOrderAfterGrossSum;
    if (this.correctionAdvanceAmountAfter > maxAmount) {
      this.correctionAdvanceAmountAfter = maxAmount;
    }

    this.calculateCorrectionAdvanceBreakdown();
  }

  // addCorrectionOrderAfterProduct i removeCorrectionOrderAfterProduct usunięte
  // KOR_ZAL używa standardowych addProduct() i removeProduct()

  /**
   * Obsługuje zmianę kwoty zaliczki po korekcie
   */
  onCorrectionAdvanceAmountAfterChange(value: number | string): void {
    this.correctionAdvanceAmountAfter = parseFloat(String(value)) || 0;

    // Sprawdź czy nie przekracza wartości zamówienia
    const maxAmount = this.correctionOrderAfterGrossSum;
    if (this.correctionAdvanceAmountAfter > maxAmount) {
      this.correctionAdvanceAmountAfter = maxAmount;
    }

    this.calculateCorrectionAdvanceBreakdown();
  }

  /**
   * Dołącza dane KOR_ZAL do invoice przed wysłaniem do API.
   * Produkty już są w invoice.products - tylko ustawiamy correction* pola.
   */
  private _attachCorrectionAdvanceData(): void {
    if (!this.correctionOrderBefore) return;

    // Deleguj do modelu — ustawia correction* pola, products już są w invoice.products
    this.invoice.attachCorrectionAdvanceData({
      orderBefore: {
        invoiceName: this.correctionOrderBefore.invoiceName,
        grossSum: this.correctionOrderBefore.grossSum,
        products: this.correctionOrderBefore.products.map(toOrderProduct)
      },
      amountBefore: this.correctionAdvanceAmountBefore,
      amountAfter: this.correctionAdvanceAmountAfter
    });
  }

  // ============================================================
  // === KOR_ROZ - korekta faktury rozliczeniowej ================
  // ============================================================

  /**
   * Inicjalizacja korekty faktury rozliczeniowej - po wybraniu korygowanego dokumentu.
   * Ustawia kwotę przed korektą, kopiuje kwotę po korekcie (domyślnie = przed).
   */
  private _initCorrectionOfSettlement(correctedDoc: DbDocument): void {
    // Waluta korekty musi być taka sama jak faktury korygowanej
    this.invoice.currency = correctedDoc.currency || 'PLN';
    this.invoice.exchangeRate = (correctedDoc as any).exchangeRate || null;

    if (this.invoice.currency !== 'PLN') {
      this.checkExchangeRate();
    }

    // Kwota przed korektą:
    // Jeśli korygujemy KOR_ROZ — bierzemy correctionSettlementAmountAfter
    // Jeśli korygujemy FakturaRozliczeniowa — bierzemy settlementAmount
    if (correctedDoc.documentType === 'FakturaKorygujacaRozliczeniowa') {
      this.correctionSettlementAmountBefore = (correctedDoc as any).correctionSettlementAmountAfter || correctedDoc.grossSum || 0;
    } else {
      this.correctionSettlementAmountBefore = (correctedDoc as any).settlementAmount || correctedDoc.grossSum || 0;
    }

    // Domyślnie po korekcie = przed korektą
    this.correctionSettlementAmountAfter = this.correctionSettlementAmountBefore;

    // Ustaw na modelu
    this.invoice.correctionSettlementAmountBefore = this.correctionSettlementAmountBefore;
    this.invoice.correctionSettlementAmountAfter = this.correctionSettlementAmountAfter;

    // === Załaduj powiązane faktury zaliczkowe z korygowanego dokumentu ===
    this._loadCorrectionAdvanceInvoices(correctedDoc);
    
    this.invoice.count();
    this.renderPreview();
  }

  /**
   * Ładuje powiązane faktury zaliczkowe z korygowanego dokumentu do KOR_ROZ.
   * Szuka ich w linkedAdvanceInvoiceIds (FakturaRozliczeniowa) lub
   * linkedAdvanceInvoices (KOR_ROZ korygująca inną KOR_ROZ).
   */
  private _loadCorrectionAdvanceInvoices(correctedDoc: DbDocument): void {
    this.correctionLinkedAdvanceInvoices = [];

    // Pobierz IDs faktur zaliczkowych z korygowanego dokumentu
    const advanceInvoiceIds = (correctedDoc as any).linkedAdvanceInvoiceIds || [];
    const advanceInvoicesMeta = (correctedDoc as any).linkedAdvanceInvoices || [];

    if (advanceInvoiceIds.length > 0) {
      // Załaduj faktury zaliczkowe z local store
      advanceInvoiceIds.forEach((id: string) => {
        const advanceInvoice = this._documentsService.getById(id);
        if (advanceInvoice) {
          this.correctionLinkedAdvanceInvoices.push(advanceInvoice);
        }
      });
    } else if (advanceInvoicesMeta.length > 0) {
      // Fallback: jeśli nie ma IDs ale są metadane (stare dokumenty lub z API)
      advanceInvoicesMeta.forEach((adv: any) => {
        const advanceInvoice = this._documentsService.getById(adv._id);
        if (advanceInvoice) {
          this.correctionLinkedAdvanceInvoices.push(advanceInvoice);
        } else {
          // Nie znaleziono w lokalnym storze — użyj metadanych
          this.correctionLinkedAdvanceInvoices.push({
            _id: adv._id,
            invoiceName: adv.invoiceName,
            documentNumber: adv.documentNumber,
            grossSum: adv.grossSum,
            ksefNumber: adv.ksefNumber
          } as any);
        }
      });
    }

    // Ustaw linkedAdvanceInvoices na modelu invoice
    this._syncCorrectionAdvanceInvoicesToModel();
  }

  /**
   * Synchronizuje listę powiązanych faktur zaliczkowych KOR_ROZ z modelem invoice
   */
  private _syncCorrectionAdvanceInvoicesToModel(): void {
    this.invoice.linkedAdvanceInvoiceIds = this.correctionLinkedAdvanceInvoices.map(inv => inv._id);
    this.invoice.linkedAdvanceInvoices = this.correctionLinkedAdvanceInvoices.map(inv => ({
      _id: inv._id,
      invoiceName: inv.invoiceName || inv.documentNumber || '',
      documentNumber: inv.documentNumber,
      grossSum: inv.grossSum || 0,
      ksefNumber: (inv as any).ksefNumber
    }));
  }

  /**
   * Otwiera dialog wyboru faktur zaliczkowych dla KOR_ROZ
   */
  showSelectAdvanceInvoicesDialogForCorrection(): void {
    const buyerNip = this.invoice.buyer?.nip;
    const alreadySelectedIds = this.correctionLinkedAdvanceInvoices.map(inv => inv._id);
    
    const dialog = this._dialogService.showSelectInvoiceDialog({
      filters: [
        // Tylko faktury zaliczkowe i korekty zaliczkowych
        (document: DbDocument) => document.documentType === 'FakturaZaliczka' || document.documentType === 'FakturaKorygujacaZaliczkowa',
        // Nie usunięte
        (document: DbDocument) => !document.isDeleted,
        // Tego samego nabywcy
        (document: DbDocument) => !buyerNip || document.buyer?.nip === buyerNip,
      ],
      selection: 'multiple',
      selectedInvoicesIds: alreadySelectedIds
    });

    const sub = dialog.subscribe({
      next: (data) => {
        if (data == null || typeof data === 'undefined') return;

        if (Array.isArray(data)) {
          const newSelectedInvoices = data
            .map(id => this._documentsService.getById(id))
            .filter(doc => doc !== null) as DbDocument[];

          // Walidacja waluty
          this.correctionLinkedAdvanceInvoices = this._validateAdvanceInvoicesCurrency(newSelectedInvoices);
          this._syncCorrectionAdvanceInvoicesToModel();
          this.renderPreview();
        }

        if (data === false) sub.unsubscribe();
      }
    });
  }

  /**
   * Usuwa fakturę zaliczkową z listy powiązanych w KOR_ROZ
   */
  removeCorrectionAdvanceInvoice(invoiceId: string): void {
    this.correctionLinkedAdvanceInvoices = this.correctionLinkedAdvanceInvoices.filter(inv => inv._id !== invoiceId);
    this._syncCorrectionAdvanceInvoicesToModel();
    this.renderPreview();
  }

  /**
   * Obsługuje zmianę kwoty pozostałej do zapłaty po korekcie
   */
  onCorrectionSettlementAmountAfterChange(value: number): void {
    this.correctionSettlementAmountAfter = value || 0;

    // Kwota rozliczenia po korekcie nie może przekroczyć sumy brutto pozycji po korekcie
    const productsGrossSum = this.invoice.products.reduce((sum, p) => sum + (p.grossValue || 0), 0);
    const maxAmount = Math.round(productsGrossSum * 100) / 100;
    if (this.correctionSettlementAmountAfter > maxAmount) {
      this._snackbarService.showSnackBar(`Kwota rozliczenia nie może przekroczyć sumy pozycji: ${Utils.toDecimal(maxAmount)}`, 'warning');
      this.correctionSettlementAmountAfter = maxAmount;
    }

    this.invoice.correctionSettlementAmountAfter = this.correctionSettlementAmountAfter;
    this.invoice.count();
    this.renderPreview();
  }

  /**
   * Sprawdza czy typ dokumentu to FakturaRozliczeniowa
   */
  get isSettlementInvoice(): boolean {
    return this.invoice?.documentType === 'FakturaRozliczeniowa';
  }

  /**
   * Ładuje listę faktur zaliczkowych dostępnych do powiązania z fakturą rozliczeniową.
   * Filtruje: tego samego nabywcy, niepowiązane z inną fakturą rozliczeniową.
   */
  loadAvailableAdvanceInvoices(): void {
    this._documentsService.currentDocuments.pipe(take(1)).subscribe(docs => {
      const allDocs = Object.values(docs) as DbDocument[];
      const buyerNip = this.invoice.buyer?.nip;

      this.availableAdvanceInvoices = allDocs.filter(doc => {
        // Tylko faktury zaliczkowe i korekty zaliczkowych
        if (doc.documentType !== 'FakturaZaliczka' && doc.documentType !== 'FakturaKorygujacaZaliczkowa') return false;
        // Nie usunięte
        if (doc.isDeleted) return false;
        // Tego samego nabywcy (jeśli ustawiony)
        if (buyerNip && doc.buyer?.nip !== buyerNip) return false;
        // Nie powiązane z inną fakturą rozliczeniową (chyba że ta faktura rozliczeniowa została usunięta)
        if (doc.linkedSettlementInvoiceId) {
          const settlement = this._documentsService.getById(doc.linkedSettlementInvoiceId);
          if (settlement && !settlement.isDeleted) return false;
        }
        return true;
      });
    });
  }

  /**
   * Otwiera dialog wyboru faktur zaliczkowych dla FakturaRozliczeniowa
   */
  showSelectAdvanceInvoicesDialog(): void {
    const buyerNip = this.invoice.buyer?.nip;
    const alreadySelectedIds = this.selectedAdvanceInvoices.map(inv => inv._id);
    
    const dialog = this._dialogService.showSelectInvoiceDialog({
      filters: [
        // Tylko faktury zaliczkowe i korekty zaliczkowych
        (document: DbDocument) => document.documentType === 'FakturaZaliczka' || document.documentType === 'FakturaKorygujacaZaliczkowa',
        // Nie usunięte
        (document: DbDocument) => !document.isDeleted,
        // Tego samego nabywcy
        (document: DbDocument) => !buyerNip || document.buyer?.nip === buyerNip,
        // Nie powiązane z inną fakturą rozliczeniową (chyba że ta rozliczeniowa została usunięta)
        (document: DbDocument) => {
          if (!document.linkedSettlementInvoiceId) return true;
          const settlement = this._documentsService.getById(document.linkedSettlementInvoiceId);
          return !settlement || settlement.isDeleted;
        }
      ],
      selection: 'multiple',
      selectedInvoicesIds: alreadySelectedIds
    });

    const sub = dialog.subscribe({
      next: (data) => {
        if (data == null || typeof data === 'undefined') return;

        if (Array.isArray(data)) {
          // Pobierz wszystkie wybrane faktury zaliczkowe
          const newSelectedInvoices = data
            .map(id => this._documentsService.getById(id))
            .filter(doc => doc !== null) as DbDocument[];

          // === Walidacja waluty faktur zaliczkowych ===
          const validatedInvoices = this._validateAdvanceInvoicesCurrency(newSelectedInvoices);
          this.selectedAdvanceInvoices = validatedInvoices;

          this.calculateSettlementData();
        }

        if (data === false) sub.unsubscribe();
      }
    });
  }

  /**
   * Waliduje walutę wybranych faktur zaliczkowych.
   * Jeśli nie ma jeszcze wybranych zaliczek - ustawia walutę dokumentu na walutę pierwszej zaliczki.
   * Jeśli już są zaliczki - odrzuca faktury z inną walutą i pokazuje komunikat.
   */
  private _validateAdvanceInvoicesCurrency(invoices: DbDocument[]): DbDocument[] {
    if (invoices.length === 0) {
      // Brak wybranych faktur - odblokuj walutę
      return invoices;
    }

    // Ustal wymaganą walutę
    const requiredCurrency = invoices[0].currency || 'PLN';

    // Sprawdź czy wszystkie faktury mają tę samą walutę
    const compatible: DbDocument[] = [];
    const incompatible: DbDocument[] = [];

    for (const inv of invoices) {
      const invCurrency = inv.currency || 'PLN';
      if (invCurrency === requiredCurrency) {
        compatible.push(inv);
      } else {
        incompatible.push(inv);
      }
    }

    if (incompatible.length > 0) {
      const incompatibleNames = incompatible.map(inv => inv.invoiceName || inv.documentNumber).join(', ');
      this._snackbarService.showSnackBar(
        `Usunięto faktury z inną walutą niż ${requiredCurrency}: ${incompatibleNames}. Faktura rozliczeniowa musi mieć taką samą walutę jak faktury zaliczkowe.`,
        'warning',
        8000
      );
    }

    // Ustaw walutę dokumentu na walutę zaliczek
    if (compatible.length > 0 && this.invoice.currency !== requiredCurrency) {
      this.invoice.currency = requiredCurrency;
      if (requiredCurrency !== 'PLN') {
        this.checkExchangeRate();
      } else {
        this.resetExchangeRate();
      }
    }

    return compatible;
  }

  /**
   * Usuwa wybraną fakturę zaliczkową z listy
   */
  removeAdvanceInvoice(invoiceId: string): void {
    this.selectedAdvanceInvoices = this.selectedAdvanceInvoices.filter(inv => inv._id !== invoiceId);
    
    // Jeśli usunięto wszystkie zaliczki, nie blokuj już waluty
    this.calculateSettlementData();
  }

  /**
   * Oblicza dane rozliczenia: sumę zaliczek i kwotę pozostałą do zapłaty
   */
  calculateSettlementData(): void {
    // Synchronizuj flagę z modelu
    this.invoice.isSettlementAmountManual = this.isSettlementAmountManual;

    // Deleguj do modelu — oblicza settlementAmount, linkedAdvanceInvoices, count()
    this.selectedAdvanceInvoicesSum = this.invoice.recalculateSettlement(this.selectedAdvanceInvoices as any);

    // Synchronizuj lokalne zmienne z modelu
    this.settlementAmount = this.invoice.settlementAmount || 0;

    // Odśwież podgląd
    this.renderPreview();
  }

  /**
   * Zwraca pogrupowany rozkład VAT kwoty rozliczenia (wg grup KSeF).
   * Dane obliczane automatycznie w invoice.count().
   */
  get groupedSettlementBreakdown(): GroupedTaxSum[] {
    return this.invoice?.getGroupedSettlementBreakdown() || [];
  }

  /**
   * Obsługuje zmianę kwoty pozostałej do zapłaty przez użytkownika
   */
  onSettlementAmountChange(value: number): void {
    this.isSettlementAmountManual = true;
    this.invoice.setSettlementAmount(value);
    this.settlementAmount = this.invoice.settlementAmount || 0;
    this.renderPreview();
  }

  /**
   * Resetuje kwotę rozliczenia do wartości domyślnej (suma brutto z pozycji)
   */
  resetSettlementAmount(): void {
    this.isSettlementAmountManual = false;
    this.invoice.resetSettlementAmount();
    this.settlementAmount = this.invoice.settlementAmount || 0;
    this.renderPreview();
  }

  processing = false
  // Call create document endpoint to save new document
  public createDocument(redirect = true) {

    // Dla FakturaZaliczka - dołącz dane zaliczki do invoice przed wysłaniem
    if (this.isAdvancePaymentInvoice && this.selectedOrder) {
      this.invoice.linkedOrderId = this.selectedOrder._id || null;
      this.invoice.advancePaymentAmount = this.advancePaymentAmount;
      // advancePaymentTaxBreakdown i linkedOrder — konstruowane na backendzie
      // Wyczyść produkty - dla FakturaZaliczka z zamówieniem produkty są w linkedOrder
      this.invoice.products = [];
    }

    // Dla FakturaRozliczeniowa - dołącz dane rozliczenia do invoice przed wysłaniem
    if (this.isSettlementInvoice && this.selectedAdvanceInvoices.length > 0) {
      this.invoice.linkedAdvanceInvoiceIds = this.selectedAdvanceInvoices.map(inv => inv._id);
      // linkedAdvanceInvoices — konstruowany na backendzie z linkedAdvanceInvoiceIds
      this.invoice.settlementAmount = this.settlementAmount;
      this.invoice.isSettlementAmountManual = this.isSettlementAmountManual;
      // settlementTaxBreakdown jest już obliczony automatycznie w count()
    }

    // Dla KOR_ZAL - dołącz dane korekty zaliczki do invoice przed wysłaniem
    if (this.isCorrectionOfAdvancePayment) {
      this._attachCorrectionAdvanceData();
    }

    // Dla KOR_ROZ - dołącz dane korekty rozliczeniowej do invoice przed wysłaniem
    if (this.isCorrectionOfSettlementInvoice) {
      this.invoice.correctionSettlementAmountAfter = this.correctionSettlementAmountAfter;
      // Dołącz powiązane faktury zaliczkowe
      this.invoice.linkedAdvanceInvoiceIds = this.correctionLinkedAdvanceInvoices.map(inv => inv._id);
      // linkedAdvanceInvoices — konstruowany na backendzie z linkedAdvanceInvoiceIds
    }

    this.processing = true
    this._documentsApiService.create(this.invoice)
      .pipe(take(1))
      .pipe(finalize(() => this.processing = false))
      .subscribe({
        next: (response: APIResponse) => this._processDocumentResponse(response, redirect, true)
      })
  }

  // Call update document endpoit to save changes
  public updateDocument(redirect = true) {

    if (Utils.isNullOrEmpty(this.invoice._id)) return

    // Dla FakturaZaliczka - dołącz dane zaliczki do invoice przed wysłaniem
    if (this.isAdvancePaymentInvoice && this.selectedOrder) {
      this.invoice.linkedOrderId = this.selectedOrder._id || null;
      this.invoice.advancePaymentAmount = this.advancePaymentAmount;
      // advancePaymentTaxBreakdown i linkedOrder — konstruowane na backendzie
      // Wyczyść produkty - dla FakturaZaliczka z zamówieniem produkty są w linkedOrder
      this.invoice.products = [];
    }

    // Dla FakturaRozliczeniowa - dołącz dane rozliczenia do invoice przed wysłaniem
    if (this.isSettlementInvoice && this.selectedAdvanceInvoices.length > 0) {
      this.invoice.linkedAdvanceInvoiceIds = this.selectedAdvanceInvoices.map(inv => inv._id);
      // linkedAdvanceInvoices — konstruowany na backendzie z linkedAdvanceInvoiceIds
      this.invoice.settlementAmount = this.settlementAmount;
      this.invoice.isSettlementAmountManual = this.isSettlementAmountManual;
      // settlementTaxBreakdown jest już obliczony automatycznie w count()
    }

    // Dla KOR_ZAL - dołącz dane korekty zaliczki do invoice przed wysłaniem
    if (this.isCorrectionOfAdvancePayment) {
      this._attachCorrectionAdvanceData();
    }

    // Dla KOR_ROZ - dołącz dane korekty rozliczeniowej do invoice przed wysłaniem
    if (this.isCorrectionOfSettlementInvoice) {
      this.invoice.correctionSettlementAmountAfter = this.correctionSettlementAmountAfter;
      // Dołącz powiązane faktury zaliczkowe
      this.invoice.linkedAdvanceInvoiceIds = this.correctionLinkedAdvanceInvoices.map(inv => inv._id);
      // linkedAdvanceInvoices — konstruowany na backendzie z linkedAdvanceInvoiceIds
    }

    this.processing = true
    this._documentsApiService.update(this.invoice._id, this.invoice)
      .pipe(take(1))
      .pipe(finalize(() => this.processing = false))
      .subscribe({
        next: (response: APIResponse) => this._processDocumentResponse(response, redirect, false)
      })
  }


  private _processDocumentResponse = (response: APIResponse, redirect: boolean, isCreating: boolean) => {
    if (response.success == false) {

      this._snackbarService.showSnackBar(
        'Nie udało się zapisać dokumentu.',
        'error',
        4000
      )
      return
    }


    if (typeof response.data != 'undefined' && typeof response.data._id != 'undefined') {
      // Update data in memomery
      this._dataSynchronizerService.next('documents', [response.data], null)
      // Update _id to avoid save confirmation - document is already saved
      this.invoice._id = response.data._id
      // Navigate to new created document
      if (redirect) this.router.navigate(['/konto/dokumenty/' + response.data._id + '/podglad'])
      // Synchronize database
      this._synchronizationService.synchronize()
      // Odśwież ustawienia użytkownika (m.in. licznik dokumentów)
      if (isCreating) {
        this._settingsService.refreshSettings()
      }
    }

    this._snackbarService.showSnackBar('Dokument został zapisany!', 'success');

    if (isCreating) {
      const bankAccount = this.bankAccounts.find(x => x.accountNumber == this.invoice.bankAccountNumber.value)
      if (typeof bankAccount === 'undefined' && !Utils.isNullOrEmpty(this.invoice.bankAccountNumber.value)) {
        this._bankAccountApiService.createBankAccount({
          accountNumber: this.invoice.bankAccountNumber.value,
          bank: 'Konto bankowe'
        })
          .pipe(take(1))
          .subscribe({
            next: (response: APIResponse) => {
              if (response.success === true) {
                this._settingsService.refreshSettings()

                this._snackbarService.showSnackBar(
                  'Konta bankowe zostały zaktualizowane.',
                  'info',
                  4000
                )
              }
            }
          })
      }

      if (Utils.isNullOrEmpty(this.settings.autocomplete.issuePlace)) {
        this.apiService.updateIssuePlace(
          this.invoice.placeHeader.value,
        )
          .pipe(take(1))
          .subscribe({
            next: (response: APIResponse) => {
              if (response.success === true) {
                this._settingsService.refreshSettings()

                this._snackbarService.showSnackBar(
                  'Zapisano domyślne miejsce wystawienia.',
                  'error',
                  4000
                )

              }
            }
          })
      }
    }
  }

  public isNumberGrossValue(value: any): boolean {
    return typeof value === 'number';
  }

  /**
   * Sprawdza czy którakolwiek pozycja ma stawkę "zw" (zwolniona)
   */
  public hasZwVatRate(): boolean {
    if (!this.invoice || !this.invoice.products) return false;
    return this.invoice.products.some((p: Product) => p.vatRate === 'zw');
  }

  /**
   * Automatyczne adnotacje dla nowych dokumentów.
   * Gdy użytkownik włączył master "autoAnnotations", przy tworzeniu nowego
   * dokumentu zaznaczamy skonfigurowane domyślne adnotacje:
   *  - procedura marży (z wybraną procedurą),
   *  - mechanizm podzielonej płatności (MPP) + auto-wybór konta VAT.
   * Zwolnienie z VAT jest obsługiwane osobno (przez stawkę "zw" pozycji) i
   * NIE zależy od tego mastera.
   */
  private applyDefaultAnnotations(userSettings: UserSettings): void {
    const result = AutoAnnotationUtils.getDefaults(
      userSettings?.settings?.autocomplete,
      this.bankAccounts
    );
    if (!result.applied) return;

    if (!this.invoice.annotations) {
      this.invoice.annotations = new InvoiceAnnotations();
    }

    // Domyślna procedura marży
    if (result.annotations.marginProcedure) {
      this.invoice.annotations.marginProcedure = result.annotations.marginProcedure;
      this.invoice['marginProcedureId'] = result.annotations.marginProcedure.procedureId;
    }

    // Domyślny mechanizm podzielonej płatności (MPP) + auto-wybór konta VAT
    if (result.annotations.isSplitPayment) {
      this.invoice.annotations.isSplitPayment = true;
      if (result.vatAccount) {
        this.invoice.setVatAccountNumber(
          result.vatAccount.accountNumber,
          result.vatAccount.bank,
          result.vatAccount.swift,
          result.vatAccount.accountDescription
        );
      }
    }

    // Odśwież kartę adnotacji jeśli już zainicjalizowana
    this.annotationsCard?.refreshFromInvoice();
  }

  /** Flaga czy domyślne ustawienia zostały już zaaplikowane dla tego dokumentu */
  private _vatExemptionDefaultsApplied = false;

  /**
   * Domyślne wartości zwolnienia z VAT z ustawień użytkownika — przekazywane do
   * karty adnotacji, by po włączeniu adnotacji wczytać je do pustych kontrolek.
   */
  get vatExemptionDefaults(): { exemptionType: any; legalBasis: string | null; showOnDocument: boolean } | null {
    const ac = this.userSettings?.settings?.autocomplete as any;
    if (!ac) return null;
    return {
      exemptionType: ac.defaultVatExemptionType || null,
      legalBasis: ac.defaultVatExemptionLegalBasis || null,
      showOnDocument: ac.showVatExemptionBase === true
    };
  }

  /**
   * Czy automatyczne zwolnienie z VAT jest aktywne — wymaga włączonego mastera
   * "Automatyczne adnotacje" oraz osobnego włącznika zwolnienia z VAT.
   */
  private isAutoVatExemptionEnabled(): boolean {
    const autocomplete = this.userSettings?.settings?.autocomplete as any;
    return autocomplete?.autoAnnotations === true && autocomplete?.defaultVatExemptionEnabled === true;
  }

  private hasVatExemptionDefaultsConfigured(): boolean {
    // Uwaga: NIE bramkujemy na włączniku — wartości kontrolek (typ, podstawa,
    // pokaż na dokumencie) ładujemy zawsze, by przy ręcznym włączeniu adnotacji
    // były już uzupełnione (zachowanie legacy). Włącznik steruje tylko tym, czy
    // adnotacja zostanie automatycznie ZAZNACZONA (patrz isAutoVatExemptionEnabled).
    const autocomplete = this.userSettings?.settings?.autocomplete;
    if (!autocomplete) return false;
    return !!(autocomplete.defaultVatExemptionType || autocomplete.defaultVatExemptionLegalBasis || autocomplete.showVatExemptionBase);
  }

  private hasDocumentVatExemption(): boolean {
    const vatExemption = this.invoice?.annotations?.vatExemption;
    if (!vatExemption) return false;
    return !!(vatExemption.enabled || vatExemption.exemptionType || vatExemption.legalBasis || vatExemption.baseId || vatExemption.customText);
  }

  private applyVatExemptionFromSettings(): void {
    const autocomplete = this.userSettings?.settings?.autocomplete;
    if (!autocomplete) return;

    if (!this.invoice.annotations) {
      this.invoice.annotations = new InvoiceAnnotations();
    }

    // Wartości kontrolek (typ, podstawa, pokaż na dokumencie) ładujemy ZAWSZE.
    // Adnotacja jest automatycznie ZAZNACZONA gdy jest pozycja "zw" (legacy) albo
    // gdy włączono automatyczne zwolnienie (master + włącznik). Gdy nic z tego —
    // kontrolki są uzupełnione, ale adnotacja pozostaje wyłączona (użytkownik
    // może ją włączyć ręcznie i ma już gotowe wartości).
    const hasZw = this.hasZwVatRate();
    const enabled = hasZw || this.isAutoVatExemptionEnabled();

    this.invoice.annotations.vatExemption = {
      enabled,
      exemptionType: autocomplete.defaultVatExemptionType || null,
      legalBasis: autocomplete.defaultVatExemptionLegalBasis || null,
      showOnDocument: autocomplete.showVatExemptionBase === true,
      baseId: null,
      customText: autocomplete.defaultVatExemptionLegalBasis || null,
      isCustom: true
    };

    this.invoice['vatExemptionBase'] = autocomplete.defaultVatExemptionLegalBasis || null;
    this.invoice['vatExemptionBaseCustom'] = !!autocomplete.defaultVatExemptionLegalBasis;
    this.invoice['showVatExemptionBase'] = autocomplete.showVatExemptionBase === true;
  }

  private syncVatExemptionSource(): void {
    if (this.mode === 'edit') {
      this._vatExemptionDefaultsApplied = this.hasDocumentVatExemption();
      this.annotationsCard?.refreshFromInvoice();
      return;
    }

    if (this.similarDocumentId) {
      this._vatExemptionDefaultsApplied = this.hasDocumentVatExemption();
      this.annotationsCard?.refreshFromInvoice();
      return;
    }

    if (this.hasVatExemptionDefaultsConfigured()) {
      this.applyVatExemptionFromSettings();
      // Uznaj defaulty za zaaplikowane tylko gdy jest pozycja "zw" (wtedy enabled=true).
      // Bez "zw" pozostaw false, by applyOrClearVatExemptionDefaults() mógł zadziałać
      // gdy użytkownik doda pozycję "zw" później.
      this._vatExemptionDefaultsApplied = this.hasZwVatRate();
      this.annotationsCard?.refreshFromInvoice();
      return;
    }

    this._vatExemptionDefaultsApplied = this.hasDocumentVatExemption();
  }

  /**
   * Aplikuje domyślne ustawienia podstawy zwolnienia z VAT gdy pojawi się stawka "zw"
   * lub czyści je gdy nie ma już żadnej pozycji ze stawką "zw".
   * Wywoływane przy każdym renderPreview()
   */
  private applyOrClearVatExemptionDefaults(): void {
    // W trybie edycji (oraz przy tworzeniu z podobnego dokumentu) nie nadpisuj
    // ani nie czyść zapisanych adnotacji zwolnienia z VAT.
    if (this.mode === 'edit' || !!this.similarDocumentId) {
      return;
    }

    const hasZw = this.hasZwVatRate();
    
    if (hasZw && !this._vatExemptionDefaultsApplied) {
      // Jest stawka "zw" i jeszcze nie zaaplikowaliśmy domyślnych - aplikuj
      const autocomplete = this.userSettings?.settings?.autocomplete;
      
      if (autocomplete && (autocomplete.defaultVatExemptionType || autocomplete.defaultVatExemptionLegalBasis || autocomplete.showVatExemptionBase)) {
        // Zainicjuj annotations.vatExemption jeśli nie istnieje
        if (!this.invoice.annotations) {
          this.invoice.annotations = new InvoiceAnnotations();
        }
        if (!this.invoice.annotations.vatExemption) {
          this.invoice.annotations.vatExemption = { enabled: false };
        }
        
        // Ustaw typ i podstawę prawną z ustawień
        if (autocomplete.defaultVatExemptionType) {
          this.invoice.annotations.vatExemption.exemptionType = autocomplete.defaultVatExemptionType;
        }
        if (autocomplete.defaultVatExemptionLegalBasis) {
          this.invoice.annotations.vatExemption.legalBasis = autocomplete.defaultVatExemptionLegalBasis;
        }

        // Zaznacz adnotację zwolnienia gdy użytkownik ma skonfigurowaną domyślną
        // podstawę prawną lub typ (sama stawka "zw" + ustawienia wystarczą).
        if (autocomplete.defaultVatExemptionType || autocomplete.defaultVatExemptionLegalBasis) {
          this.invoice.annotations.vatExemption.enabled = true;
        }

        // "Pokaż podstawę na dokumencie" sterowane osobnym ustawieniem.
        if (autocomplete.showVatExemptionBase === true) {
          this.invoice.annotations.vatExemption.enabled = true;
          this.invoice.annotations.vatExemption.showOnDocument = true;
        }
        
        this._vatExemptionDefaultsApplied = true;
        
        // Odśwież annotations-card żeby pokazał nowe wartości w UI
        this.annotationsCard?.refreshFromInvoice();
      }
    } else if (!hasZw && this._vatExemptionDefaultsApplied && !this.isAutoVatExemptionEnabled()) {
      // Nie ma stawki "zw" - wyczyść TYLKO automatycznie zaaplikowane ustawienia
      // (gdy automatyczne zwolnienie jest włączone, zostawiamy je zaznaczone).
      // Nie czyść jeśli użytkownik ręcznie włączył zwolnienie z VAT
      if (this.invoice.annotations?.vatExemption) {
        this.invoice.annotations.vatExemption.legalBasis = null;
        this.invoice.annotations.vatExemption.exemptionType = null;
        this.invoice.annotations.vatExemption.enabled = false;
        this.invoice.annotations.vatExemption.showOnDocument = false;
      }
      this._vatExemptionDefaultsApplied = false;
      
      // Odśwież annotations-card żeby pokazał wyczyszczone wartości
      this.annotationsCard?.refreshFromInvoice();
    }
  }

  /**
   * Handles currency change and checks exchange rate if needed
   */
  public onCurrencyChange(newCurrency: string) {
    // Blokada zmiany waluty dla korekty - waluta musi iść z faktury korygowanej
    if (this.invoice.documentType === 'FakturaKorygujaca' || this.invoice.documentType === 'FakturaKorygujacaZaliczkowa' || this.invoice.documentType === 'FakturaKorygujacaRozliczeniowa') {
      return;
    }

    // Blokada zmiany waluty dla faktury zaliczkowej z wybranym zamówieniem - waluta musi iść z zamówienia
    if (this.isAdvancePaymentInvoice && this.selectedOrder) {
      return;
    }

    // Blokada zmiany waluty dla faktury rozliczeniowej z wybranymi fakturami zaliczkowymi
    if (this.isSettlementInvoice && this.selectedAdvanceInvoices.length > 0) {
      return;
    }

    this.invoice.currency = newCurrency;
    
    // Check exchange rate if currency is not PLN
    if (this.invoice.currency != 'PLN') {
      this.checkExchangeRate();
    } else {
      // Reset exchange rate if currency is PLN
      this.resetExchangeRate();
    }
  }

  /**
   * Toggles receiver field visibility
   */
  public toggleReceiverVisibility() {
    if (this.invoice.hasReceiver) {
      // Hide receiver and reset it
      this.invoice.hasReceiver = false;
      this.invoice.receiver = new Company({}); // Reset receiver
    } else {
      // Show receiver
      this.invoice.hasReceiver = true;
    }
    this.renderPreview();
  }

  /**
   * Przełącza oznaczenie JST (Jednostka Samorządu Terytorialnego) na fakturze.
   * Zaznaczenie wymusza pokazanie pola odbiorcy (Podmiot3 z Rola=8).
   */
  public toggleKsefJst(checked: boolean) {
    this.invoice.ksefJst = checked;
    if (checked && !this.invoice.hasReceiver) {
      this.invoice.hasReceiver = true;
    }
    this.renderPreview();
  }

}
